const translations = {
  en: {
    auth: {
      signIn: "Sign In",
      signUp: "Sign Up",
      createAccount: "Create Account",
      email: "Email",
      password: "Password",
      fullName: "Full Name",
      phoneNumber: "Phone Number",
      primary_role: "primary_role",
      customer: "Customer",
      driver: "Driver",
      vehicleType: "Vehicle Type",
      selectVehicleType: "Select Vehicle Type",
      walker: "Walker",
      bicycle: "Bicycle",
      bike: "Motorcycle",
      car: "Car",
      van: "Van",
      truck: "Truck",
      login: "Sign In",
      register: "Create Account",
      logout: "Logout",
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: "Already have an account?",
      loading: "Loading...",
      verify: "Verify",
      verified: "Verified",
      showPassword: "Mostrar",
      hidePassword: "Ocultar",
      resendVerification: "Reenviar Verificación",
      emailVerificationRequired:
        "Se requiere verificación de correo electrónico",
      verifyYourEmail: "Verifica tu correo electrónico",
    },
    orders: {
      myOrders: "My Orders",
      createOrder: "Create New Order",
      createNewOrder: "Create New Order",
      cancel: "Cancel",
      orderTitle: "Order Title",
      description: "Description",
      packageDescription: "Package Description",
      packageWeight: "Package Weight (kg)",
      estimatedValue: "Estimated Value ($)",
      specialInstructions: "Special Instructions",
      estimatedDelivery: "Estimated Delivery Date",
      price: "Offered Price ($)",
      publishOrder: "Publish Order",
      publishingOrder: "Publishing Order...",
      pickupLocation: "Pickup Location",
      deliveryLocation: "Delivery Location",
      country: "Country",
      city: "City",
      area: "Area",
      street: "Street",
      building: "Building",
      floor: "Floor #",
      apartment: "Apartment",
      contactName: "Contact Name",
      selectCountry: "Select Country",
      enterCity: "Enter city",
      enterArea: "Enter area",
      enterStreet: "Enter street",
      buildingNumber: "Building #",
      aptNumber: "Apt #",
      contactPerson: "Contact person",
      orderNumber: "Order #",
      pickup: "Pickup",
      delivery: "Delivery",
      package: "Package",
      weight: "Weight",
      value: "Value",
      instructions: "Instructions",
      trackOrder: "Track Order",
      viewReviews: "View Reviews",
      noOrders: "No orders available",
      required: "Required",
      optional: "Optional",
      orderTitleRequired: "Order title is required",
      priceRequired: "Price is required",
      pickupCountryRequired: "Pickup country is required",
      pickupCityRequired: "Pickup city is required",
      pickupContactRequired: "Pickup contact name is required",
      deliveryCountryRequired: "Delivery country is required",
      deliveryCityRequired: "Delivery city is required",
      deliveryContactRequired: "Delivery contact name is required",
      placeYourBid: "Place Your Bid",
      messageOptional: "Message (Optional)",
      bidding: "Bidding...",
      pickingUp: "Picking Up...",
      updating: "Updating...",
      completing: "Completing...",
      markAsPickedUp: "Mark as Picked Up",
      markAsInTransit: "Mark as In Transit",
      markAsDelivered: "Mark as Delivered",
      confirmDelivery: "Confirm Delivery",
      acceptedBid: "Accepted Bid",
      assignedDriver: "Assigned Driver",
      orderAccepted:
        "Your order has been accepted. The driver will pick it up soon.",
      packagePickedUp: "Your package has been picked up and is on the way!",
      packageInTransit:
        "Your package is in transit and will be delivered soon!",
      orderCompletedSuccessfully: "Order completed successfully!",
      orderCancelled: "Order was cancelled.",
      clearFilter: "Clear Filter",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      acceptBid: "Accept Bid",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "إلغاء الطلب",
      orderNumberLabel: "رقم الطلب #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      driverMarkedDelivered: "Driver marked as delivered.",
      confirmReceivePackage: "Please confirm receiving the package.",
      waitingCustomerConfirmation: "Waiting for customer confirmation...",
      customerReviews: "Customer Reviews",
      driverReviews: "Driver Reviews",
      pickup: "Pickup",
      delivery: "Delivery",
      cancelOrder: "Cancel Order",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Pending Bids",
      accepted: "Accepted",
      pickedUp: "Picked Up",
      inTransit: "In Transit",
      delivered: "Delivered",
      courierDelivered: "Delivered by Courier",
      customerDelivered: "Delivery Confirmed",
      completed: "Completed",
      cancelled: "Cancelled",
    },
    driver: {
      activeOrders: "Active Orders",
      availableBids: "Available Bids",
      myHistory: "My History",
      updateLocation: "Update Location",
      locationUpdated: "Location Updated",
      enableLocation: "Enable location for better order visibility",
      locationDenied: "Location access denied",
      placeBid: "Place Bid",
      placingBid: "Bidding...",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      message: "Message (optional)",
      driverBids: "Driver Bids",
      acceptBid: "Accept Bid",
      acceptingBid: "Accepting...",
      markPickedUp: "Mark as Picked Up",
      markInTransit: "Mark as In Transit",
      markDelivered: "Mark as Delivered",
      pickingUp: "Picking Up...",
      updating: "Updating...",
      completing: "Completing...",
      distanceFromPickup: "Distance from pickup",
      filterByCity: "Filter by City",
      allCities: "All Cities",
      clearFilter: "Clear Filter",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
    },
    reputation: {
      customerReputation: "Customer Reputation",
      driverReputation: "Driver Reputation",
      rating: "Rating",
      deliveries: "Deliveries",
      reviews: "Reviews",
      memberSince: "Member Since",
      reviewsGiven: "Reviews Given",
      viewReviews: "View Reviews",
      given: "Given",
      verifyAccount: "Verify Account",
      verified: "Verified",
      unverified: "Unverified",
      overallRating: "Overall Rating",
      bidPrice: "Bid Price",
      new: "New",
      unknown: "Unknown",
    },
    reviews: {
      submitReview: "Submit Review",
      reviewDriver: "Review Driver",
      reviewCustomer: "Review Customer",
      reviewPlatform: "Review Platform",
      overallRating: "Overall Rating",
      professionalism: "Professionalism",
      communication: "Communication",
      timeliness: "Timeliness",
      packageCondition: "Package Condition",
      comment: "Comment (Optional)",
      shareExperience: "Share your experience...",
      cancel: "Cancel",
      submit: "Submit Review",
      submitting: "Submitting...",
      provideRating: "Please provide an overall rating",
      orderReviews: "Order Reviews",
      noReviews: "No reviews yet for this order",
      reviewType: "Review Type",
      reviewing: "Reviewing",
    },
    notifications: {
      notifications: "Notifications",
      noNotifications: "No notifications",
      newNotification: "New notification",
    },
    tracking: {
      orderTracking: "Order Tracking",
      liveTracking: "Live Tracking",
      currentStatus: "Current Status",
      currentLocation: "Current Location",
      timeline: "Timeline",
      orderCreated: "Order Created",
      bidAccepted: "Bid Accepted",
      packagePickedUp: "Package Picked Up",
      locationHistory: "Location History",
      orderNumber: "Order #",
      close: "Close",
      liveTrackingActive: "Live Tracking Active",
      connecting: "Connecting...",
      selectedLocation: "Selected Location",
      coordinates: "Coordinates",
      copyCoordinates: "Copy Coordinates",
    },
    messages: {
      orderPublished:
        "Order published successfully! Waiting for drivers in your area.",
      bidPlaced: "Bid placed successfully!",
      bidAccepted: "Bid accepted successfully! Driver notified.",
      orderAccepted:
        "Your order has been accepted. The driver will pick it up soon.",
      orderPickedUp: "Your package has been picked up and is on the way!",
      orderInTransit: "Your package is in transit and will be delivered soon!",
      orderCompleted: "Order completed successfully!",
      orderCancelled: "Order was cancelled.",
      reviewSubmitted: "Review submitted successfully!",
      allFieldsRequired: "All fields required",
      vehicleTypeRequired: "Vehicle type is required for drivers",
      completeCaptcha: "Please complete the captcha",
      enterValidBid: "Enter a valid bid price",
      fillRequiredFields: "Please fill all required fields",
      connectionIssue:
        "Connection issue: Failed to get user. Please try refreshing the page.",
      locationAccessFailed:
        "Location access failed. Please enable location services.",
      afterVerification:
        "After admin verifies your account, please refresh this page to see the verification badge.",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      confirm: "Confirm",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      search: "Search",
      filter: "Filter",
      clear: "Clear",
      close: "Close",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
      optional: "Optional",
      required: "Required",
      appName: "Matrix Heroes",
      subtitle: "P2P Delivery & Ride-Hailing Platform",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    system: {
      criticalError: "CRITICAL ERROR",
      systemFailure: "SYSTEM FAILURE",
      unexpectedError: "An unexpected error has disrupted the Matrix.",
      unrecoverableException:
        "The system has encountered an unrecoverable exception.",
      rebootSystem: "↻ REBOOT SYSTEM",
      returnToSource: "⌂ RETURN TO SOURCE",
      debugTrace: "Debug Trace",
      checkingServer: "⟳ Checking server...",
      autoRetryInProgress: "↻ Auto-retry in progress",
      lastCheck: "Last",
    },
    balance: {
      myBalance: "💰 My Balance",
      driverAccount: "Driver Account",
      accountFrozen: "Account Frozen",
      frozenMessage:
        "Your balance is currently frozen. Please contact support.",
      availableBalance: "Available Balance",
      pending: "Pending",
      held: "Held",
      totalBalance: "Total Balance",
      deposit: "Deposit",
      withdraw: "Withdraw",
      recentTransactions: "Recent Transactions",
      viewAll: "View All →",
      noTransactions: "No transactions yet",
      makeFirstDeposit: "Make Your First Deposit",
      loadingBalance: "Loading balance...",
      retry: "Retry",
      back: "← Back",
      completed: "Completed",
      failed: "Failed",
      cancelled: "Cancelled",
      codEarnings: "💵 COD Earnings Summary",
      cashCollected: "💵 Cash Collected",
      platformCommission: "🏢 Platform Commission (10%)",
      netEarnings: "✅ Net Earnings",
      currentBalance: "💰 Current Balance",
      debt: "Debt",
      lowBalanceWarning:
        "⚠️ Your balance is low. Please deposit to continue bidding.",
      blockedWarning:
        "🚫 Bidding blocked. Please top up to reach -100 EGP threshold.",
      availableForBidding: "📝 Available for Bidding",
      cannotBid: "Bidding blocked",
      depositNow: "Deposit Now",
      totalDeliveries: "Total Deliveries",
      completedPayments: "Completed Payments",
      earningsSummary: "Earnings Summary",
      lifetimeEarnings: "Lifetime Earnings",
      totalDeposits: "Total Deposits",
      totalWithdrawals: "Total Withdrawals",
      totalTransactions: "Total Transactions",
    },
    withdrawal: {
      title: "💸 Withdraw Funds",
      availableBalance: "Available Balance:",
      dailyLimit: "Daily Limit:",
      monthlyLimit: "Monthly Limit:",
      amount: "Withdrawal Amount",
      description: "Description",
      descriptionPlaceholder: "e.g., Monthly withdrawal",
      selectDestination: "Select Destination",
      walletNumber: "Wallet or Instapay Number",
      confirmWithdrawal: "Confirm Withdrawal",
      processingFee: "Processing Fee:",
      youWillReceive: "You will receive:",
      destination: "Destination:",
      processingNotice:
        "Withdrawal requests are usually processed within 24-48 hours.",
      enterVerificationCode: "Enter Verification Code",
      verificationInstructions:
        "We sent a 6-digit verification code to your email. Enter it below to confirm your withdrawal.",
      verificationCode: "Verification Code",
      processing: "Processing Withdrawal...",
      processingWait: "Please wait while we process your withdrawal request.",
      successTitle: "Withdrawal Request Submitted!",
      successMessage:
        "Your withdrawal request has been submitted successfully.",
      successNote: "You will be notified once the withdrawal is processed.",
      cancel: "Cancel",
      continue: "Continue",
      back: "Back",
      confirm: "Confirm Withdrawal",
      confirmCode: "Confirm Code",
      verifying: "Verifying...",
      done: "Done",
      amountPositive: "Amount must be positive",
      minWithdrawal: "Minimum withdrawal is",
      maxWithdrawal: "Maximum withdrawal is",
      insufficientBalance: "Insufficient balance",
      dailyLimitExceeded: "Daily limit is",
      walletRequired: "Wallet or Instapay number is required",
      enterVerificationCodeError:
        "Please enter the 6-digit verification code sent to your email",
    },
    transactionHistory: {
      title: "📊 Transaction History",
      exportCSV: "Export CSV",
      searchPlaceholder: "Search transactions...",
      allTypes: "All Types",
      allStatuses: "All Statuses",
      startDate: "Start Date",
      endDate: "End Date",
      clearFilters: "Clear Filters",
      loading: "Loading transactions...",
      retry: "Retry",
      noTransactions: "No transactions found",
      noTransactionsHint: "Try adjusting your filters or search query",
      type: "Type",
      description: "Description",
      date: "Date",
      amount: "Amount",
      status: "Status",
      balanceAfter: "Balance After",
      actions: "Actions",
      cancel: "Cancel",
      previous: "Previous",
      next: "Next",
      pageInfo: "Page {current} of {total}",
      statusCompleted: "Completed",
      statusPending: "Pending",
      statusFailed: "Failed",
      statusCancelled: "Cancelled",
      typeDeposit: "Deposit",
      typeWithdrawal: "Withdrawal",
      typeOrderPayment: "Order Payment",
      typeOrderRefund: "Order Refund",
      typeEarnings: "Earnings",
      typeCommission: "Commission",
      cancelConfirm: "Are you sure you want to cancel this withdrawal request?",
      cancelledFromHistory: "Cancelled from transaction history",
    },
    balanceStatement: {
      title: "📄 Balance Statement",
      back: "Back",
      generateTitle: "Generate Statement",
      selectPeriod: "Select Period:",
      startDate: "Start Date",
      endDate: "End Date",
      generate: "Generate Statement",
      generating: "Generating...",
      previewTitle: "Statement Preview",
      downloadPDF: "Download PDF",
      downloadCSV: "Download CSV",
      statementType: "Balance Statement",
      openingBalance: "Opening Balance",
      totalDeposits: "Total Deposits",
      totalWithdrawals: "Total Withdrawals",
      totalEarnings: "Total Earnings",
      totalDeductions: "Total Deductions",
      closingBalance: "Closing Balance",
      transactionDetails: "Transaction Details ({count} transactions)",
      periodLast7Days: "Last 7 days",
      periodLast30Days: "Last 30 days",
      periodLast3Months: "Last 3 months",
      periodLast6Months: "Last 6 months",
      periodLastYear: "Last year",
      periodCustom: "Custom range",
      errorMissingDates: "Please select both start and end dates",
      errorFutureStart: "Start date cannot be in the future",
      errorFutureEnd: "End date cannot be in the future",
      errorEndBeforeStart: "End date must be after start date",
      errorMaxPeriod: "Maximum statement period is 1 year",
    },
    profile: {
      title: "Profile",
      uploadPhoto: "Upload Photo",
      verified: "Verified",
      unverified: "Unverified",
      userRole: "User",
      switchRole: "Switch Role",
      editProfile: "Edit Profile",
      cancel: "Cancel",
      saveChanges: "Save Changes",
      activityStats: "Activity Stats",
      completedDeliveries: "Completed Deliveries",
      averageRating: "Average Rating",
      viewEarnings: "View Earnings",
      goToDashboard: "Go to Dashboard",
      financials: "Financials",
      cashInHand: "Cash in Hand",
      platformFee: "Platform Fee",
      financialsNote:
        "* You must have enough balance to cover upfront payments for cash orders.",
      personalInfo: "Personal Info",
      fullName: "Full Name",
      phoneNumber: "Phone Number",
      language: "Language",
      theme: "Theme",
      gender: "Gender",
      default: "Default",
      male: "Male",
      female: "Female",
      other: "Other",
      driverSettings: "Driver Settings",
      vehicleType: "Vehicle Type",
      license: "License",
      availableForOrders: "Available for Orders",
      status: "Status",
      online: "ONLINE",
      offline: "OFFLINE",
      paymentMethods: "Payment Methods",
      noPaymentMethods: "No payment methods added.",
      defaultMethod: "Default Method",
      remove: "Remove",
      userId: "User ID",
    },
    courier: {
      tier: {
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        teamLeader: "Team Leader",
        juniorDesc: "New courier starting their journey",
        midDesc: "Experienced courier with 200+ deliveries",
        seniorDesc: "Expert courier with 800+ deliveries and high rating",
        teamLeaderDesc: "Senior courier leading a team of couriers"
      },
      profile: {
        notFound: "Courier not found",
        privateOrNotExist: "This profile is private or does not exist",
        backToDirectory: "Back to Directory",
        loadError: "Failed to load profile",
        courierSince: "Courier since {date}",
        license: "License: {number}",
        locationUnknown: "Location not specified",
        completedDeliveries: "Completed Deliveries",
        rating: "Rating",
        tenureDays: "Days on Platform",
        teamSize: "Team Size",
        leadingTeam: "Leading Team",
        memberOfTeam: "Member of Team",
        members: "members",
        teamDeliveries: "Team Deliveries",
        teamAvgRating: "Team Avg Rating",
        verifiedMembers: "Verified Members",
        teamLeader: "Team Leader",
        member: "Member",
        careerTimeline: "Career Timeline",
        noCareerEvents: "No career events yet",
        viewDetails: "View Details",
        profileSettings: "Profile Settings",
        editProfile: "Edit Profile",
        visibilityTitle: "Public Profile",
        visibilityExplanation: "Enabling this makes your professional courier profile visible to other users on the platform. The following information will be shown:",
        visibilityFieldName: "Your name and profile photo",
        visibilityFieldPhoto: "Profile picture",
        visibilityFieldTier: "Seniority tier (Junior/Mid/Senior/Team Leader)",
        visibilityFieldRating: "Overall rating",
        visibilityFieldDeliveries: "Total completed deliveries",
        visibilityFieldTenure: "Tenure on platform",
        visibilityFieldLocation: "City and service area zone (never exact address)",
        visibilityFieldVerified: "Verified badge status",
        visibilityFieldLicense: "Professional license number",
        visibilityNeverShown: "Never shown: phone number, email, exact address, precise coordinates, or private messages.",
        makeProfilePublic: "Make my profile public",
        profileIsPublic: "Your profile is visible to other couriers and customers",
        profileIsPrivate: "Your profile is private - only you and admins can see it"
      },
      career: {
        joinedPlatform: "Joined the platform",
        tierPromoted: "Promoted to {tier}",
        tierDemoted: "Demoted to {tier}",
        verified: "Account verified",
        milestone100: "Reached 100 deliveries milestone",
        milestone500: "Reached 500 deliveries milestone",
        milestone1000: "Reached 1,000 deliveries milestone",
        badgeEarned: "Earned badge: {badge}",
        joinedTeam: "Joined team: {team}",
        leftTeam: "Left team: {team}",
        becameTeamLeader: "Became team leader of: {team}",
        profileMadePublic: "Made profile public",
        profileMadePrivate: "Made profile private"
      },
      directory: {
        title: "Courier Directory",
        subtitle: "Discover professional couriers in the Matrix network",
        filters: "Filters",
        filterByTier: "Filter by Tier",
        filterByCity: "Filter by City",
        filterByCountry: "Filter by Country",
        allTiers: "All Tiers",
        cityPlaceholder: "Enter city name...",
        countryPlaceholder: "Enter country name...",
        clearFilters: "Clear Filters",
        showingResults: "Showing {from}-{to} of {count} couriers",
        noCouriers: "No couriers found",
        noCouriersFiltered: "No couriers match your filters. Try adjusting them.",
        noCouriersYet: "No public courier profiles yet. Be the first to opt in!",
        deliveries: "Deliveries",
        rating: "Rating",
        verified: "Verified",
        memberSince: "Member since {year}"
      }
    },
    reviews: {
      navTitle: "REVIEWS",
      backToLanding: "Back to Landing",
      title: "Voice of the People",
      subtitle: "Trusted experiences from the Matrix network.",
      writeReview: "Write a Review",
      cancelReview: "Cancel Review",
      shareTitle: "Share your experience",
      rating: "Rating",
      comment: "Comment",
      commentPlaceholder: "Tell us about your delivery...",
      submit: "Submit Review",
      submitting: "Transmitting...",
      success: "Review submitted successfully",
      error: "Failed to submit. Please try again.",
      sortBy: "SORT BY:",
      sortUpvotes: "Highest Upvotes",
      sortRecent: "Most Recent",
      loading: "Initializing Matrix data stream...",
      empty: "No signals detected yet. Be the first to broadcast.",
      report: "Report",
      reportConfirm: "Report this review as inappropriate?",
      reportSuccess:
        "Review reported. Thank you for keeping the community safe.",
      flagCount: "Flag Count",
    },
    landing: {
      vision: "Vision",
      liveStats: "Live Stats",
      reviews: "Reviews",
      login: "Login",
      evolutionBadge: "Evolution Badge: Beta Phase",
      heroTitle: "P2P Delivery Marketplace",
      heroSubtitle:
        "The world's first decentralized logistics network powered by the people, for the people. Experience the freedom of peer-to-peer delivery.",
      cta: "Get Started",
      voiceOfPeople: "Voice of the People",
      watchManifesto: "Watch Manifesto",
      statsTitle: "Live Matrix Statistics",
      couriers: "Registered Couriers",
      clients: "Registered Clients",
      vendors: "Registered Vendors",
      deliveries: "Total Deliveries",
      uptime: "System Uptime",
      licensed: "Licensed",
      growing: "Growing",
      partners: "Partners",
      lifetime: "Lifetime",
      online: "Online",
      visionTitle: "Our Core Vision",
      visionSubtitle: "The four pillars that define the Matrix.",
      visionFreedom: "Freedom",
      visionFreedomDesc:
        "Break free from traditional logistics constraints. Delivery without borders.",
      visionJustice: "Justice",
      visionJusticeDesc:
        "Fair wages for couriers. Fair prices for customers. No hidden fees.",
      visionEfficiency: "Efficiency",
      visionEfficiencyDesc:
        "AI-optimized routing ensures the fastest possible delivery times.",
      visionTransparency: "Transparency",
      visionTransparencyDesc:
        "Open source protocols. Real-time tracking. Verify everything.",
      roadmapTitle: "Global Roadmap",
      phase1: "Awakening",
      phase2: "Expansion",
      phase3: "Liberation",
      phase4: "The Source",
      statusCompleted: "Completed",
      statusActive: "Active",
      statusUpcoming: "Upcoming",
      statusPlanned: "Planned",
      footer: "© 2025 Matrix Delivery. A Living Platform.",
    },
    activeOrder: {
      orderNumber: "Order #",
      pickup: "Pickup",
      delivery: "Delivery",
      package: "Package",
      weight: "Weight",
      value: "Value",
      instructions: "Instructions",
      reviewDriver: "Review Driver",
      reviewCustomer: "Review Customer",
      reviewPlatform: "Review Platform",
      viewReviews: "View Reviews",
      deleteOrder: "Delete Order",
      googleMaps: "Google Maps",
      chat: "Chat",
      to: "To",
      eta: "ETA",
      speed: "Speed",
      km: "km",
      min: "min",
      kmh: "km/h",
    },
    settings: {
      title: "Settings",
      close: "Close",
      languageSettings: "Language Settings",
      languageDesc:
        "Choose your preferred language for the application interface.",
      comingSoon: "More settings coming soon insha Allah...",
      footer: "Matrix Delivery Settings",
    },
    driverEarnings: {
      title: "Driver Earnings",
      last7Days: "Last 7 Days",
      last30Days: "Last 30 Days",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      customRange: "Custom Range",
      clearFilter: "Clear Filter",
      showingData: "Showing data from",
      to: "to",
      today: "Today",
      thisWeek: "This Week",
      trendTitle: "Earnings Trend (Last 7 Days)",
      exportCSV: "Export CSV",
      exportPDF: "Export PDF",
      recentDeliveries: "Recent Deliveries",
      date: "Date",
      time: "Time",
      orderNum: "Order #",
      rating: "Rating",
      amount: "Amount",
      noOrders: "No completed orders yet.",
      previous: "Previous",
      next: "Next",
      pageInfo: "Page",
    },
    languages: {
      english: "English",
      spanish: "Español",
      french: "Français",
      chinese: "中文",
      german: "Deutsch",
      portuguese: "Português",
      arabic: "العربية",
      russian: "Русский",
      japanese: "日本語",
      turkish: "Türkçe",
      urdu: "اردو",
      hindi: "हिन्दी",
    },
    bidding: {
      walker: "Walker",
      bicycle: "Bicycle",
      scooter: "Scooter",
      motorbike: "Motorbike",
      car: "Car",
      van: "Van",
      truck: "Truck",
      useRecommendedBid: "Use Recommended Bid",
      openInGoogleMaps: "Open in Google Maps",
      modifyBid: "Modify Bid",
      withdrawBid: "Withdraw Bid",
      costPerKmPlaceholder: "Cost per km",
      waitingPerHourPlaceholder: "Waiting per hour",
      distanceFromPickup: "Distance from pickup",
      minimumBid: "Minimum Bid",
      platformFee: "Platform Fee",
      estimatedEarnings: "Estimated Earnings",
      minimumBidWarning: "Minimum bid is 10 LE",
    },
    menu: {
      menuTitle: "Menu",
      homeActiveOrders: "Home / Active Orders",
      earningsDashboard: "Earnings Dashboard",
      notifications: "Notifications",
      balance: "Balance",
      myHistory: "My History",
      settings: "Settings",
      adminPanel: "Admin Panel",
      driverActions: "Driver Actions",
      availableBids: "Available Bids",
      ordersMap: "Orders Map",
      myBids: "My Bids",
      location: "Location",
      driverStatus: "Driver Status",
      goOffline: "Go Offline",
      goOnline: "Go Online",
      legal: "Legal",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      refundPolicy: "Refund Policy",
      driverAgreement: "Driver Agreement",
      cookiePolicy: "Cookie Policy",
      system: "System",
      contactUs: "Contact Us",
      cryptoTest: "Crypto Test",
      supportDeveloper: "Support Developer",
      delivery: "delivery",
      deliveries: "deliveries",
      downloadApp: "Download Android App",
      downloadAppDesc: "Get the latest APK from GitHub releases",
      downloadApk: "Download Latest APK",
      vendorDashboard: "Vendor Dashboard",
    },
    footer: {
      onlineDrivers: "Online Drivers",
      onlineCustomers: "Online Customers",
      onlineSupport: "Online Support",
      onlineAdmins: "Online Admins",
      ordersToday: "Orders Today",
      activeOrders: "Active Orders",
      countries: "Countries",
      systemLoad: "System Load",
      version: "Matrix Delivery v",
      commit: "Commit",
    },
  },
  ar: {
    auth: {
      signIn: "تسجيل الدخول",
      signUp: "إنشاء حساب",
      createAccount: "إنشاء حساب جديد",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      fullName: "الاسم الكامل",
      phoneNumber: "رقم الهاتف",
      primary_role: "الدور",
      customer: "عميل",
      driver: "سائق",
      vehicleType: "نوع المركبة",
      selectVehicleType: "اختر نوع المركبة",
      walker: "مترجل",
      bicycle: "دراجة",
      bike: "موتوسيكل",
      car: "سيارة",
      van: "شاحنة صغيرة",
      truck: "شاحنة",
      login: "تسجيل الدخول",
      register: "إنشاء حساب",
      logout: "تسجيل الخروج",
      dontHaveAccount: "ليس لديك حساب؟",
      alreadyHaveAccount: "لديك حساب بالفعل؟",
      loading: "جارٍ التحميل...",
      verify: "توثيق",
      verified: "موثق",
      resendVerification: "إعادة إرسال التحقق",
      emailVerificationRequired: "التحقق من البريد الإلكتروني مطلوب",
      verifyYourEmail: "تحقق من بريدك الإلكتروني",
      showPassword: "عرض",
      hidePassword: "إخفاء",
      forgotPassword: "نسيت كلمة المرور؟",
      forgotPasswordInstructions: "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
      sendResetLink: "إرسال رابط إعادة التعيين",
      sending: "جارٍ الإرسال...",
      checkYourEmail: "تحقق من بريدك الإلكتروني",
      resetEmailSent: "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      resetEmailInstructions: "إذا كان البريد الإلكتروني مسجلاً، ستتلقى رابطاً لإعادة تعيين كلمة المرور. يرجى التحقق من صندوق البريد الوارد ومجلد الرسائل غير المرغوب فيها.",
      backToLogin: "العودة لتسجيل الدخول",
      passwordResetSuccess: "تم إعادة تعيين كلمة المرور بنجاح!",
      passwordResetSuccessMessage: "تم تحديث كلمة المرور الخاصة بك. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
      redirectingToLogin: "جارٍ التحويل لتسجيل الدخول...",
      invalidResetLink: "رابط إعادة التعيين غير صالح",
      invalidResetLinkMessage: "رابط إعادة التعيين هذا غير صالح أو منتهي الصلاحية. يرجى طلب إعادة تعيين كلمة مرور جديدة.",
      resetYourPassword: "إعادة تعيين كلمة المرور",
      enterNewPassword: "أدخل كلمة المرور الجديدة أدناه.",
      newPassword: "كلمة المرور الجديدة",
      confirmNewPassword: "تأكيد كلمة المرور الجديدة",
      resetting: "جارٍ إعادة التعيين...",
      resetPassword: "إعادة تعيين كلمة المرور",
    },
    orders: {
      myOrders: "طلباتي",
      createOrder: "إنشاء طلب جديد",
      cancel: "إلغاء",
      orderTitle: "عنوان الطلب",
      description: "الوصف",
      packageDescription: "وصف الطرد",
      packageWeight: "وزن الطرد (كجم)",
      estimatedValue: "القيمة المقدرة ($)",
      specialInstructions: "تعليمات خاصة",
      estimatedDelivery: "تاريخ التسليم المتوقع",
      price: "السعر المعروض ($)",
      publishOrder: "نشر الطلب",
      publishingOrder: "جارٍ نشر الطلب...",
      pickupLocation: "موقع الاستلام",
      deliveryLocation: "موقع التسليم",
      country: "البلد",
      city: "المدينة",
      area: "المنطقة",
      street: "الشارع",
      building: "المبنى",
      floor: "الطابق",
      apartment: "الشقة",
      contactName: "اسم جهة الاتصال",
      selectCountry: "اختر البلد",
      enterCity: "أدخل المدينة",
      enterArea: "أدخل المنطقة",
      enterStreet: "أدخل الشارع",
      buildingNumber: "رقم المبنى",
      aptNumber: "رقم الشقة",
      contactPerson: "جهة الاتصال",
      orderNumber: "رقم الطلب #",
      pickup: "الاستلام",
      delivery: "التسليم",
      package: "الطرد",
      weight: "الوزن",
      value: "القيمة",
      instructions: "التعليمات",
      trackOrder: "تتبع الطلب",
      viewReviews: "عرض التقييمات",
      noOrders: "لا توجد طلبات متاحة",
      required: "مطلوب",
      optional: "اختياري",
      orderTitleRequired: "عنوان الطلب مطلوب",
      priceRequired: "السعر مطلوب",
      pickupCountryRequired: "بلد الاستلام مطلوب",
      pickupCityRequired: "مدينة الاستلام مطلوبة",
      pickupContactRequired: "اسم جهة اتصال الاستلام مطلوب",
      deliveryCountryRequired: "بلد التسليم مطلوب",
      deliveryCityRequired: "مدينة التسليم مطلوبة",
      deliveryContactRequired: "اسم جهة اتصال التسليم مطلوب",
      placeYourBid: "ضع عرضك",
      messageOptional: "رسالة (اختياري)",
      bidding: "تقديم عرض...",
      pickingUp: "جارٍ الاستلام...",
      updating: "جارٍ التحديث...",
      completing: "جارٍ الإكمال...",
      markAsPickedUp: "تحديد كمستلم",
      markAsInTransit: "تحديد قيد التوصيل",
      markAsDelivered: "تحديد كمسلّم",
      acceptedBid: "العرض المقبول",
      assignedDriver: "السائق المعين",
      orderAccepted: "تم قبول طلبك. سيقوم السائق باستلامه قريباً.",
      packagePickedUp: "تم استلام طردك وهو في الطريق!",
      packageInTransit: "طردك قيد التوصيل وسيتم تسليمه قريباً!",
      orderCompletedSuccessfully: "تم إكمال الطلب بنجاح!",
      orderCancelled: "تم إلغاء الطلب.",
      activeOrders: "الطلبات النشطة",
      orderDetails: "تفاصيل الطلب",
      title: "العنوان",
      contactPhone: "رقم الاتصال",
      packageDetails: "تفاصيل الحزمة",
      estimatedDeliveryDate: "تاريخ التسليم المتوقع",
      createNewOrder: "إنشاء طلب جديد",
      clearFilter: "مسح التصفية",
      allCities: "جميع المدن",
      filterByCity: "تصفية حسب المدينة",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      acceptBid: "قبول العرض",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancelar Pedido",
      orderNumberLabel: "Pedido N°",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "تم إلغاء الطلب.",
      driverMarkedDelivered: "قام السائق بتسجيل التسليم.",
      confirmReceivePackage: "يرجى تأكيد استلام الطرد.",
      waitingCustomerConfirmation: "في انتظار تأكيد العميل...",
      customerReviews: "تقييمات العملاء",
      driverReviews: "تقييمات السائقين",
      pickup: "الاستلام",
      delivery: "التسليم",
    },
    status: {
      pendingBids: "في انتظار العروض",
      accepted: "مقبول",
      pickedUp: "تم الاستلام",
      inTransit: "قيد التوصيل",
      delivered: "تم التسليم",
      courierDelivered: "تم التسليم بواسطة السائق",
      customerDelivered: "تم تأكيد التسليم",
      completed: "مكتمل",
      cancelled: "ملغى",
    },
    driver: {
      activeOrders: "الطلبات النشطة",
      availableBids: "العروض المتاحة",
      myHistory: "سجلي",
      updateLocation: "تحديث الموقع",
      locationUpdated: "تم تحديث الموقع",
      enableLocation: "قم بتفعيل الموقع لرؤية الطلبات بشكل أفضل",
      locationDenied: "تم رفض الوصول إلى الموقع",
      placeBid: "تقديم عرض",
      placingBid: "جارٍ تقديم العرض...",
      bidAmount: "قيمة العرض ($)",
      pickupTime: "وقت الاستلام",
      message: "رسالة (اختياري)",
      driverBids: "عروض السائقين",
      acceptBid: "قبول العرض",
      acceptingBid: "جارٍ القبول...",
      markPickedUp: "تحديد كمستلم",
      markInTransit: "تحديد قيد التوصيل",
      markDelivered: "تحديد كمسلّم",
      pickingUp: "جارٍ الاستلام...",
      updating: "جارٍ التحديث...",
      completing: "جارٍ الإكمال...",
      distanceFromPickup: "المسافة من موقع الاستلام",
      minimumBid: "الحد الأدنى للمزايدة",
      platformFee: "عمولة المنصة",
      estimatedEarnings: "الأرباح المتوقعة",
      minimumBidWarning: "الحد الأدنى للمزايدة 10 جنيه",
      filterByCity: "تصفية حسب المدينة",
      allCities: "جميع المدن",
      clearFilter: "مسح التصفية",
      noActiveOrders: "لا توجد طلبات نشطة",
      noAvailableBids: "لا توجد عروض متاحة",
      noOrderHistory: "لا يوجد سجل للطلبات",
      noOrdersAvailable: "لا توجد طلبات متاحة",
    },
    reputation: {
      customerReputation: "سمعة العميل",
      driverReputation: "سمعة السائق",
      rating: "التقييم",
      deliveries: "التوصيلات",
      reviews: "التقييمات",
      memberSince: "عضو منذ",
      reviewsGiven: "التقييمات المعطاة",
      viewReviews: "عرض التقييمات",
      given: "معطى",
      verifyAccount: "توثيق الحساب",
      verified: "موثّق",
      unverified: "غير موثّق",
      overallRating: "التقييم الإجمالي",
      bidPrice: "سعر العرض",
      new: "جديد",
      unknown: "غير معروف",
    },
    reviews: {
      submitReview: "إرسال تقييم",
      reviewDriver: "تقييم السائق",
      reviewCustomer: "تقييم العميل",
      reviewPlatform: "تقييم المنصة",
      overallRating: "التقييم الإجمالي",
      professionalism: "الاحترافية",
      communication: "التواصل",
      timeliness: "الالتزام بالوقت",
      packageCondition: "حالة الطرد",
      comment: "تعليق (اختياري)",
      shareExperience: "شارك تجربتك...",
      cancel: "إلغاء",
      submit: "إرسال التقييم",
      submitting: "جارٍ الإرسال...",
      provideRating: "يرجى تقديم تقييم إجمالي",
      orderReviews: "تقييمات الطلب",
      noReviews: "لا توجد تقييمات لهذا الطلب بعد",
      reviewType: "نوع التقييم",
      reviewing: "تقييم",
    },
    notifications: {
      notifications: "الإشعارات",
      noNotifications: "لا توجد إشعارات",
      newNotification: "إشعار جديد",
    },
    tracking: {
      orderTracking: "تتبع الطلب",
      liveTracking: "التتبع المباشر",
      currentStatus: "الحالة الحالية",
      currentLocation: "الموقع الحالي",
      timeline: "الجدول الزمني",
      orderCreated: "تم إنشاء الطلب",
      bidAccepted: "تم قبول العرض",
      packagePickedUp: "تم استلام الطرد",
      locationHistory: "سجل المواقع",
      orderNumber: "رقم الطلب #",
      close: "إغلاق",
      liveTrackingActive: "التتبع المباشر نشط",
      connecting: "جارٍ الاتصال...",
      selectedLocation: "الموقع المحدد",
      coordinates: "الإحداثيات",
      copyCoordinates: "نسخ الإحداثيات",
    },
    messages: {
      orderPublished: "تم نشر الطلب بنجاح! في انتظار السائقين في منطقتك.",
      bidPlaced: "تم تقديم العرض بنجاح!",
      bidAccepted: "تم قبول العرض بنجاح! تم إخطار السائق.",
      orderAccepted: "تم قبول طلبك. سيقوم السائق باستلامه قريباً.",
      orderPickedUp: "تم استلام طردك وهو في الطريق!",
      orderInTransit: "طردك قيد التوصيل وسيتم تسليمه قريباً!",
      orderCompleted: "تم إكمال الطلب بنجاح!",
      orderCancelled: "تم إلغاء الطلب.",
      reviewSubmitted: "تم إرسال التقييم بنجاح!",
      allFieldsRequired: "جميع الحقول مطلوبة",
      vehicleTypeRequired: "نوع المركبة مطلوب للسائقين",
      completeCaptcha: "يرجى إكمال التحقق",
      enterValidBid: "أدخل قيمة عرض صالحة",
      fillRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
      connectionIssue:
        "مشكلة في الاتصال: فشل في الحصول على معلومات المستخدم. يرجى تحديث الصفحة.",
      locationAccessFailed: "فشل الوصول إلى الموقع. يرجى تفعيل خدمات الموقع.",
      afterVerification:
        "بعد أن يقوم المسؤول بتوثيق حسابك، يرجى تحديث هذه الصفحة لرؤية شارة التوثيق.",
    },
    common: {
      loading: "جارٍ التحميل...",
      error: "خطأ",
      success: "نجاح",
      confirm: "تأكيد",
      cancel: "إلغاء",
      save: "حفظ",
      delete: "حذف",
      edit: "تعديل",
      search: "بحث",
      filter: "تصفية",
      clear: "مسح",
      close: "إغلاق",
      back: "رجوع",
      next: "التالي",
      previous: "السابق",
      yes: "نعم",
      no: "لا",
      optional: "اختياري",
      required: "مطلوب",
      appName: "أبطال المصفوفة",
      subtitle: "السوق الحرة للتوصيل ",
      selectLanguage: "اختر اللغة",
      vendorName: "اسم البائع",
      keyword: "كلمة مفتاحية",
      lat: "خط العرض",
      lng: "خط الطول",
      radius: "نصف القطر (كم)",
      category: "الفئة",
      vendorId: "معرف البائع",
      itemName: "اسم العنصر",
      createVendor: "إنشاء بائع",
      yourLocation: "موقعك",
      driverCurrentLocation: "موقع السائق الحالي",
      priceAsc: "السعر: من الأقل للأعلى",
      priceDesc: "السعر: من الأعلى للأقل",
      orderStatus: "حالة الطلب",
      orderData: "بيانات الطلب",
      driverCoords: "إحداثيات السائق",
      costPerKm: "التكلفة لكل كم",
      waitingPerHour: "الانتظار لكل ساعة",
      notifications: "الإشعارات",
      profile: "الملف الشخصي",
      menu: "القائمة",
      reorder: "إعادة ترتيب",
    },
    system: {
      criticalError: "خطأ حرج",
      systemFailure: "فشل النظام",
      unexpectedError: "حدث خطأ غير متوقع في النظام.",
      unrecoverableException: "واجه النظام استثناءً لا يمكن استعادته.",
      rebootSystem: "↻ إعادة تشغيل النظام",
      returnToSource: "⌂ العودة للرئيسية",
      debugTrace: "تتبع الأخطاء",
      checkingServer: "⟳ جارٍ فحص الخادم...",
      autoRetryInProgress: "↻ إعادة المحاولة تلقائياً",
      lastCheck: "آخر فحص",
    },
    balance: {
      myBalance: "💰 رصيدي",
      driverAccount: "حساب السائق",
      accountFrozen: "الحساب مجمد",
      frozenMessage: "رصيدك مجمد حالياً. يرجى التواصل مع الدعم.",
      availableBalance: "الرصيد المتاح",
      pending: "قيد الانتظار",
      held: "محجوز",
      totalBalance: "الرصيد الإجمالي",
      deposit: "إيداع",
      withdraw: "سحب",
      recentTransactions: "المعاملات الأخيرة",
      viewAll: "عرض الكل ←",
      noTransactions: "لا توجد معاملات بعد",
      makeFirstDeposit: "قم بأول إيداع لك",
      loadingBalance: "جارٍ تحميل الرصيد...",
      retry: "إعادة المحاولة",
      back: "→ رجوع",
      completed: "مكتمل",
      failed: "فشل",
      cancelled: "ملغى",
      codEarnings: "💵 ملخص أرباح الدفع عند الاستلام",
      cashCollected: "💵 النقود المحصلة",
      platformCommission: "🏢 عمولة المنصة (10%)",
      netEarnings: "✅ صافي الأرباح",
      currentBalance: "💰 الرصيد الحالي",
      debt: "مديونية",
      lowBalanceWarning: "⚠️ رصيدك منخفض. يرجى الإيداع للمتابعة.",
      blockedWarning: "🚫 تم حظر المزايدة. يرجى الإيداع للوصول لـ -100 جنيه.",
      availableForBidding: "📝 متاح للمزايدة",
      cannotBid: "تم الحظر",
      depositNow: "أودع الآن",
      totalDeliveries: "إجمالي التوصيلات",
      completedPayments: "المدفوعات المكتملة",
      earningsSummary: "ملخص الأرباح",
      lifetimeEarnings: "الأرباح الإجمالية",
      totalDeposits: "إجمالي الإيداعات",
      totalWithdrawals: "إجمالي السحوبات",
      totalTransactions: "إجمالي المعاملات",
    },
    withdrawal: {
      title: "💸 سحب الرصيد",
      availableBalance: "الرصيد المتاح:",
      dailyLimit: "الحد اليومي:",
      monthlyLimit: "الحد الشهري:",
      amount: "مبلغ السحب",
      description: "الوصف",
      descriptionPlaceholder: "مثال: سحب شهري",
      selectDestination: "اختر الوجهة",
      walletNumber: "رقم المحفظة أو انستاباي",
      confirmWithdrawal: "تأكيد السحب",
      processingFee: "رسوم المعالجة:",
      youWillReceive: "ستحصل على:",
      destination: "الوجهة:",
      processingNotice: "عادة ما يتم معالجة طلبات السحب خلال 24-48 ساعة.",
      enterVerificationCode: "أدخل رمز التحقق",
      verificationInstructions:
        "أرسلنا رمز تحقق مكون من 6 أرقام إلى بريدك الإلكتروني. أدخله أدناه لتأكيد السحب.",
      verificationCode: "رمز التحقق",
      processing: "جاري معالجة السحب...",
      processingWait: "يرجى الانتظار أثناء معالجة طلب السحب.",
      successTitle: "تم إرسال طلب السحب!",
      successMessage: "تم إرسال طلب السحب بنجاح.",
      successNote: "سيتم إشعارك عند معالجة السحب.",
      cancel: "إلغاء",
      continue: "متابعة",
      back: "رجوع",
      confirm: "تأكيد السحب",
      confirmCode: "تأكيد الرمز",
      verifying: "جاري التحقق...",
      done: "تم",
      amountPositive: "يجب أن يكون المبلغ موجباً",
      minWithdrawal: "الحد الأدنى للسحب",
      maxWithdrawal: "الحد الأقصى للسحب",
      insufficientBalance: "رصيد غير كافٍ",
      dailyLimitExceeded: "الحد اليومي",
      walletRequired: "رقم المحفظة أو انستاباي مطلوب",
      enterVerificationCodeError:
        "يرجى إدخال رمز التحقق المكون من 6 أرقام المرسل إلى بريدك الإلكتروني",
    },
    transactionHistory: {
      title: "📊 سجل المعاملات",
      exportCSV: "تصدير CSV",
      searchPlaceholder: "بحث في المعاملات...",
      allTypes: "كل الأنواع",
      allStatuses: "كل الحالات",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      clearFilters: "مسح التصفية",
      loading: "جاري تحميل المعاملات...",
      retry: "إعادة المحاولة",
      noTransactions: "لا توجد معاملات",
      noTransactionsHint: "جرب تعديل المرشحات أو البحث",
      type: "النوع",
      description: "الوصف",
      date: "التاريخ",
      amount: "المبلغ",
      status: "الحالة",
      balanceAfter: "الرصيد بعد",
      actions: "إجراءات",
      cancel: "إلغاء",
      previous: "السابق",
      next: "التالي",
      pageInfo: "صفحة {current} من {total}",
      statusCompleted: "مكتمل",
      statusPending: "قيد الانتظار",
      statusFailed: "فشل",
      statusCancelled: "ملغى",
      typeDeposit: "إيداع",
      typeWithdrawal: "سحب",
      typeOrderPayment: "دفع طلب",
      typeOrderRefund: "استرداد طلب",
      typeEarnings: "أرباح",
      typeCommission: "عمولة",
      cancelConfirm: "هل أنت متأكد أنك تريد إلغاء طلب السحب هذا؟",
      cancelledFromHistory: "تم الإلغاء من سجل المعاملات",
    },
    balanceStatement: {
      title: "📄 كشف الحساب",
      back: "رجوع",
      generateTitle: "إصدار كشف الحساب",
      selectPeriod: "اختر الفترة:",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      generate: "إصدار الكشف",
      generating: "جاري الإصدار...",
      previewTitle: "معاينة الكشف",
      downloadPDF: "تحميل PDF",
      downloadCSV: "تحميل CSV",
      statementType: "كشف حساب",
      openingBalance: "الرصيد الافتتاحي",
      totalDeposits: "إجمالي الإيداعات",
      totalWithdrawals: "إجمالي السحوبات",
      totalEarnings: "إجمالي الأرباح",
      totalDeductions: "إجمالي الاستقطاعات",
      closingBalance: "الرصيد الختامي",
      transactionDetails: "تفاصيل المعاملات ({count} معاملة)",
      periodLast7Days: "آخر 7 أيام",
      periodLast30Days: "آخر 30 يوم",
      periodLast3Months: "آخر 3 شهور",
      periodLast6Months: "آخر 6 شهور",
      periodLastYear: "آخر سنة",
      periodCustom: "فترة مخصصة",
      errorMissingDates: "يرجى تحديد تاريخ البدء والانتهاء",
      errorFutureStart: "لا يمكن أن يكون تاريخ البدء في المستقبل",
      errorFutureEnd: "لا يمكن أن يكون تاريخ الانتهاء في المستقبل",
      errorEndBeforeStart: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
      errorMaxPeriod: "أقصى فترة للكشف هي سنة واحدة",
    },
    profile: {
      title: "الملف الشخصي",
      uploadPhoto: "تحميل صورة",
      verified: "تم التحقق",
      unverified: "غير موثق",
      userRole: "مستخدم",
      switchRole: "تبديل الدور",
      editProfile: "تعديل الملف الشخصي",
      cancel: "إلغاء",
      saveChanges: "حفظ التغييرات",
      activityStats: "إحصائيات النشاط",
      completedDeliveries: "عمليات التوصيل المكتملة",
      averageRating: "متوسط التقييم",
      viewEarnings: "عرض الأرباح",
      goToDashboard: "الذهاب للوحة التحكم",
      financials: "المعلومات المالية",
      cashInHand: "نقد في اليد",
      platformFee: "رسوم المنصة",
      financialsNote:
        "* يجب أن يكون لديك رصيد كافٍ لتغطية الدفعات المقدمة للطلبات النقدية.",
      personalInfo: "المعلومات الشخصية",
      fullName: "الاسم الكامل",
      phoneNumber: "رقم الهاتف",
      language: "اللغة",
      theme: "المظهر",
      gender: "النوع",
      default: "افتراضي",
      male: "ذكر",
      female: "أنثى",
      other: "آخر",
      driverSettings: "إعدادات السائق",
      vehicleType: "نوع المركبة",
      license: "الرخصة",
      availableForOrders: "متاح للطلبات",
      status: "الحالة",
      online: "متصل",
      offline: "非连接",
      paymentMethods: "طرق الدفع",
      noPaymentMethods: "لم يتم إضافة طرق دفع.",
      defaultMethod: "الطريقة الافتراضية",
      remove: "إزالة",
      userId: "رقم المستخدم",
    },
    courier: {
      tier: {
        junior: "مبتدئ",
        mid: "متوسط",
        senior: "كبير",
        teamLeader: "قائد فريق",
        juniorDesc: "مندوب جديد في بداية مسيرته",
        midDesc: "مندوب خبير مع أكثر من 200 توصيلة",
        seniorDesc: "مندوب خبير مع أكثر من 800 توصيلة وتقييم عالي",
        teamLeaderDesc: "مندوب كبير يقود فريق من المندوبين"
      },
      profile: {
        notFound: "المندوب غير موجود",
        privateOrNotExist: "هذا الملف الشخصي خاص أو غير موجود",
        backToDirectory: "العودة للدليل",
        loadError: "فشل تحميل الملف الشخصي",
        courierSince: "مندوب منذ {date}",
        license: "الرخصة: {number}",
        locationUnknown: "الموقع غير محدد",
        completedDeliveries: "التوصيلات المكتملة",
        rating: "التقييم",
        tenureDays: "الأيام على المنصة",
        teamSize: "حجم الفريق",
        leadingTeam: "قائد فريق",
        memberOfTeam: "عضو في فريق",
        members: "أعضاء",
        teamDeliveries: "توصيلات الفريق",
        teamAvgRating: "متوسط تقييم الفريق",
        verifiedMembers: "الأعضاء الموثقون",
        teamLeader: "قائد الفريق",
        member: "عضو",
        careerTimeline: "الجدول الزمني للمسيرة",
        noCareerEvents: "لا توجد أحداث مسيرة بعد",
        viewDetails: "عرض التفاصيل",
        profileSettings: "إعدادات الملف الشخصي",
        editProfile: "تعديل الملف الشخصي",
        visibilityTitle: "الملف الشخصي العام",
        visibilityExplanation: "تمكين هذا يجعل ملفك المهني مرئياً للمستخدمين الآخرين على المنصة. سيتم عرض المعلومات التالية:",
        visibilityFieldName: "اسمك وصورة ملفك الشخصي",
        visibilityFieldPhoto: "الصورة الشخصية",
        visibilityFieldTier: "مستوى الخبرة (مبتدئ/متوسط/كبير/قائد فريق)",
        visibilityFieldRating: "التقييم الإجمالي",
        visibilityFieldDeliveries: "إجمالي التوصيلات المكتملة",
        visibilityFieldTenure: "السنين على المنصة",
        visibilityFieldLocation: "المدينة ومنطقة الخدمة (لا يتم عرض العنوان الدقيق أبداً)",
        visibilityFieldVerified: "حالة شارة التوثيق",
        visibilityFieldLicense: "رقم الرخصة المهنية",
        visibilityNeverShown: "لا يتم عرضه أبداً: رقم الهاتف، البريد الإلكتروني، العنوان الدقيق، الإحداثيات الدقيقة، أو الرسائل الخاصة.",
        makeProfilePublic: "جعل ملفي عاماً",
        profileIsPublic: "ملفك الشخصي مرئي للمندوبين والعملاء الآخرين",
        profileIsPrivate: "ملفك الشخصي خاص - أنت والمشرفون فقط من يمكنهم رؤيته"
      },
      career: {
        joinedPlatform: "انضم للمنصة",
        tierPromoted: "تمت ترقية إلى {tier}",
        tierDemoted: "تم تخفيض المستوى إلى {tier}",
        verified: "تم توثيق الحساب",
        milestone100: "الوصول لمعلم 100 توصيلة",
        milestone500: "الوصول لمعلم 500 توصيلة",
        milestone1000: "الوصول لمعلم 1000 توصيلة",
        badgeEarned: "حصل على شارة: {badge}",
        joinedTeam: "انضم للفريق: {team}",
        leftTeam: "غادر الفريق: {team}",
        becameTeamLeader: "أصبح قائد فريق: {team}",
        profileMadePublic: "جعل الملف عاماً",
        profileMadePrivate: "جعل الملف خاصاً"
      },
      directory: {
        title: "دليل المندوبين",
        subtitle: "اكتشف المندوبين المحترفين في شبكة ماتريكس",
        filters: "التصفيات",
        filterByTier: "تصفية حسب المستوى",
        filterByCity: "تصفية حسب المدينة",
        filterByCountry: "تصفية حسب الدولة",
        allTiers: "جميع المستويات",
        cityPlaceholder: "أدخل اسم المدينة...",
        countryPlaceholder: "أدخل اسم الدولة...",
        clearFilters: "مسح التصفية",
        showingResults: "عرض {from}-{to} من {count} مندوب",
        noCouriers: "لم يتم العثور على مندوبين",
        noCouriersFiltered: "لا يوجد مندوبون يطابقون تصفياتك. حاول تعديلها.",
        noCouriersYet: "لا توجد ملفات مندوبين عامة بعد. كن أول من ينضم!",
        deliveries: "التوصيلات",
        rating: "التقييم",
        verified: "موثق",
        memberSince: "عضو منذ {year}"
      }
    },
    reviews: {
      navTitle: "المراجعات",
      backToLanding: "العودة للرئيسية",
      title: "صوت الناس",
      subtitle: "تجارب موثوقة من شبكة ماتريكس.",
      writeReview: "اكتب مراجعة",
      cancelReview: "إلغاء المراجعة",
      shareTitle: "شارك تجربتك",
      rating: "التقييم",
      comment: "التعليق",
      commentPlaceholder: "أخبرنا عن عملية التوصيل...",
      submit: "إرسال المراجعة",
      submitting: "جاري الإرسال...",
      success: "تم إرسال المراجعة بنجاح",
      error: "فشل الإرسال. حاول مرة أخرى.",
      sortBy: "ترتيب حسب:",
      sortUpvotes: "الأكثر تصويتاً",
      sortRecent: "الأحدث",
      loading: "جاري تحميل بيانات ماتريكس...",
      empty: "لا توجد إشارات مكتشفة بعد. كن أول من يبث.",
      report: "إبلاغ",
      reportConfirm: "إبلاغ عن هذه المراجعة كغير ملائمة؟",
      reportSuccess: "تم الإبلاغ. شكرا لحفاظك على أمان المجتمع.",
      flagCount: "عدد البلاغات",
    },
    landing: {
      vision: "الرؤية",
      liveStats: "إحصائيات حية",
      reviews: "المراجعات",
      login: "تسجيل الدخول",
      evolutionBadge: "شارة التطور: مرحلة تجريبية",
      heroTitle: "السوق الحرة لتوصيل الأفراد و الطلبات",
      heroSubtitle:
        "أول شبكة خدمات لوجستية لامركزية في العالم مدعومة من الناس ولأجل الناس. جرب حرية التوصيل المباشر.",
      cta: "ابدأ الآن",
      voiceOfPeople: "صوت الناس",
      watchManifesto: "شاهد البيان",
      statsTitle: "إحصائيات ماتريكس المباشرة",
      couriers: "السعاة المسجلين",
      clients: "العملاء المسجلين",
      vendors: "البائعين المسجلين",
      deliveries: "إجمالي التوصيلات",
      uptime: "وقت تشغيل النظام",
      licensed: "مرخص",
      growing: "متزايد",
      partners: "شركاء",
      lifetime: "مدى الحياة",
      online: "متصل",
      visionTitle: "رؤيتنا الأساسية",
      visionSubtitle: "الأركان الأربعة التي تحدد هوية ماتريكس.",
      visionFreedom: "الحرية",
      visionFreedomDesc:
        "تحرر من قيود الخدمات اللوجستية التقليدية. توصيل بلا حدود.",
      visionJustice: "العدالة",
      visionJusticeDesc:
        "أجور عادلة للسعاة. أسعار عادلة للعملاء. لا رسوم خفية.",
      visionEfficiency: "الاحترافية",
      visionEfficiencyDesc:
        "يضمن التوجيه المحسن بالذكاء الاصطناعي أسرع أوقات توصيل ممكنة.",
      visionTransparency: "الشفافية",
      visionTransparencyDesc:
        "بروتوكولات مفتوحة المصدر. تتبع في الوقت الحقيقي. تحقق من كل شيء.",
      roadmapTitle: "خارطة الطريق العالمية",
      phase1: "الصحوة",
      phase2: "التوسع",
      phase3: "التحرير",
      phase4: "المصدر",
      statusCompleted: "مكتمل",
      statusActive: "نشط",
      statusUpcoming: "قادم",
      statusPlanned: "مخطط",
      footer: "© 2025 توصيل ماتريكس. منصة حية.",
    },
    activeOrder: {
      orderNumber: "رقم الطلب",
      pickup: "استلام",
      delivery: "توصيل",
      package: "الطرد",
      weight: "الوزن",
      value: "القيمة",
      instructions: "تعليمات",
      reviewDriver: "تقييم السائق",
      reviewCustomer: "تقييم العميل",
      reviewPlatform: "تقييم المنصة",
      viewReviews: "عرض المراجعات",
      deleteOrder: "حذف الطلب",
      googleMaps: "خرائط جوجل",
      chat: "محادثة",
      to: "إلى",
      eta: "الوقت المتوقع",
      speed: "السرعة",
      km: "كم",
      min: "دقيقة",
      kmh: "كم/س",
    },
    settings: {
      title: "الإعدادات",
      close: "إغلاق",
      languageSettings: "إعدادات اللغة",
      languageDesc: "اختر لغتك المفضلة لواجهة التطبيق.",
      comingSoon: "المزيد من الإعدادات قريبا إن شاء الله...",
      footer: "إعدادات توصيل ماتريكس",
    },
    driverEarnings: {
      title: "أرباح السائق",
      last7Days: "آخر 7 أيام",
      last30Days: "آخر 30 يوم",
      thisMonth: "هذا الشهر",
      lastMonth: "الشهر الماضي",
      customRange: "فترة مخصصة",
      clearFilter: "مسح الفلتر",
      showingData: "عرض البيانات من",
      to: "إلى",
      today: "اليوم",
      thisWeek: "هذا الأسبوع",
      trendTitle: "مؤشر الأرباح (آخر 7 أيام)",
      exportCSV: "تصدير CSV",
      exportPDF: "تصدير PDF",
      recentDeliveries: "أحدث التوصيلات",
      date: "التاريخ",
      time: "الوقت",
      orderNum: "رقم الطلب",
      rating: "التقييم",
      amount: "المبلغ",
      noOrders: "لا توجد طلبات مكتملة بعد.",
      previous: "سابق",
      next: "تالي",
      pageInfo: "صفحة",
    },
    languages: {
      english: "الإنجليزية",
      spanish: "الإسبانية",
      french: "الفرنسية",
      chinese: "الصينية",
      german: "الألمانية",
      portuguese: "البرتغالية",
      arabic: "العربية",
      russian: "الروسية",
      japanese: "اليابانية",
      turkish: "التركية",
      urdu: "الأردية",
    },
    bidding: {
      walker: "مشي",
      bicycle: "دراجة هوائية",
      scooter: "سكوتر",
      motorbike: "دراجة نارية",
      car: "سيارة",
      van: "فان",
      truck: "شاحنة",
      useRecommendedBid: "استخدام العرض الموصى به",
      openInGoogleMaps: "فتح في خرائط جوجل",
      modifyBid: "تعديل العرض",
      withdrawBid: "سحب العرض",
      costPerKmPlaceholder: "التكلفة لكل كم",
      waitingPerHourPlaceholder: "الانتظار لكل ساعة",
      distanceFromPickup: "المسافة من موقع الاستلام",
    },
    menu: {
      menuTitle: "القائمة",
      homeActiveOrders: "الرئيسية / الطلبات النشطة",
      earningsDashboard: "لوحة الأرباح",
      notifications: "الإشعارات",
      balance: "الرصيد",
      myHistory: "سجلي",
      settings: "الإعدادات",
      adminPanel: "لوحة الإدارة",
      driverActions: "إجراءات السائق",
      availableBids: "العروض المتاحة",
      ordersMap: "خريطة الطلبات",
      myBids: "عروضي",
      location: "الموقع",
      driverStatus: "حالة السائق",
      goOffline: "الانتقال لوضع عدم الاتصال",
      goOnline: "الانتقال لوضع الاتصال",
      legal: "قانوني",
      privacyPolicy: "سياسة الخصوصية",
      termsOfService: "شروط الخدمة",
      refundPolicy: "سياسة الاسترداد",
      driverAgreement: "اتفاقية السائق",
      cookiePolicy: "سياسة ملفات تعريف الارتباط",
      system: "النظام",
      contactUs: "اتصل بنا",
      cryptoTest: "اختبار العملات الرقمية",
      supportDeveloper: "دعم المطوّر",
      delivery: "توصيلة",
      deliveries: "توصيلات",
      downloadApp: "تنزيل تطبيق أندرويد",
      downloadAppDesc: "احصل على أحدث APK من إصدارات GitHub",
      downloadApk: "تنزيل أحدث APK",
      vendorDashboard: "لوحة البائع",
    },
    footer: {
      onlineDrivers: "السائقون المتصلون",
      onlineCustomers: "العملاء المتصلون",
      onlineSupport: "الدعم المتصل",
      onlineAdmins: "المسؤولون المتصلون",
      ordersToday: "طلبات اليوم",
      activeOrders: "الطلبات النشطة",
      countries: "الدول",
      systemLoad: "حمل النظام",
      version: "توصيل ماتريكس الإصدار ",
      commit: "التزام",
    },
  },
  es: {
    auth: {
      signIn: "Iniciar Sesión",
      signUp: "Registrarse",
      createAccount: "Crear Cuenta",
      email: "Correo Electrónico",
      password: "Contraseña",
      fullName: "Nombre Completo",
      phoneNumber: "Número de Teléfono",
      primary_role: "Rol",
      customer: "Cliente",
      driver: "Conductor",
      vehicleType: "Tipo de Vehículo",
      selectVehicleType: "Seleccionar Tipo de Vehículo",
      walker: "Caminante",
      bicycle: "Bicicleta",
      bike: "Motocicleta",
      car: "Coche",
      van: "Furgoneta",
      truck: "Camión",
      login: "Iniciar Sesión",
      register: "Crear Cuenta",
      logout: "Cerrar Sesión",
      dontHaveAccount: "¿No tienes cuenta?",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      loading: "Cargando...",
      verify: "Verificar",
      verified: "Verificado",
      showPassword: "Mostrar",
      hidePassword: "Ocultar",
      resendVerification: "Reenviar Verificación",
      emailVerificationRequired:
        "Se requiere verificación de correo electrónico",
      verifyYourEmail: "Verifica tu correo electrónico",
    },
    orders: {
      myOrders: "Mis Pedidos",
      createOrder: "Crear Nuevo Pedido",
      cancel: "Cancelar",
      orderTitle: "Título del Pedido",
      description: "Descripción",
      packageDescription: "Descripción del Paquete",
      packageWeight: "Peso del Paquete (kg)",
      estimatedValue: "Valor Estimado ($)",
      specialInstructions: "Instrucciones Especiales",
      estimatedDelivery: "Fecha de Entrega Estimada",
      price: "Precio Ofrecido ($)",
      publishOrder: "Publicar Pedido",
      publishingOrder: "Publicando Pedido...",
      pickupLocation: "Ubicación de Recogida",
      deliveryLocation: "Ubicación de Entrega",
      country: "País",
      city: "Ciudad",
      area: "Área",
      street: "Calle",
      building: "Edificio",
      floor: "Piso",
      apartment: "Apartamento",
      contactName: "Nombre de Contacto",
      selectCountry: "Seleccionar País",
      enterCity: "Ingresar ciudad",
      enterArea: "Ingresar área",
      enterStreet: "Ingresar calle",
      buildingNumber: "N° Edificio",
      aptNumber: "N° Apt",
      contactPerson: "Persona de contacto",
      orderNumber: "Pedido N°",
      pickup: "Recogida",
      delivery: "Entrega",
      package: "Paquete",
      weight: "Peso",
      value: "Valor",
      instructions: "Instrucciones",
      trackOrder: "Rastrear Pedido",
      viewReviews: "Ver Reseñas",
      noOrders: "No hay pedidos disponibles",
      required: "Requerido",
      optional: "Opcional",
      orderTitleRequired: "El título del pedido es requerido",
      priceRequired: "El precio es requerido",
      pickupCountryRequired: "El país de recogida es requerido",
      pickupCityRequired: "La ciudad de recogida es requerida",
      pickupContactRequired: "El nombre de contacto de recogida es requerido",
      deliveryCountryRequired: "El país de entrega es requerido",
      deliveryCityRequired: "La ciudad de entrega es requerida",
      deliveryContactRequired: "El nombre de contacto de entrega es requerido",
      placeYourBid: "Coloca tu oferta",
      messageOptional: "Mensaje (Opcional)",
      bidding: "Ofertando...",
      pickingUp: "Recogiendo...",
      updating: "Actualizando...",
      completing: "Completando...",
      markAsPickedUp: "Marcar como Recogido",
      markAsInTransit: "Marcar como En Tránsito",
      markAsDelivered: "Marcar como Entregado",
      acceptedBid: "Oferta Aceptada",
      assignedDriver: "Conductor Asignado",
      orderAccepted:
        "Tu pedido ha sido aceptado. El conductor lo recogerá pronto.",
      packagePickedUp: "Tu paquete ha sido recogido y está en camino.",
      packageInTransit: "Tu paquete está en tránsito y será entregado pronto.",
      orderCompletedSuccessfully: "Pedido completado exitosamente.",
      orderCancelled: "El pedido fue cancelado.",
      createNewOrder: "Crear Nuevo Pedido",
      clearFilter: "Limpiar Filtro",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Ofertas Pendientes",
      accepted: "Aceptado",
      pickedUp: "Recogido",
      inTransit: "En Tránsito",
      delivered: "Entregado",
      courierDelivered: "Entregado por el repartidor",
      customerDelivered: "Entrega confirmada",
      completed: "Completado",
      cancelled: "Cancelado",
    },
    driver: {
      activeOrders: "Pedidos Activos",
      availableBids: "Ofertas Disponibles",
      myHistory: "Mi Historial",
      updateLocation: "Actualizar Ubicación",
      locationUpdated: "Ubicación Actualizada",
      enableLocation: "Habilitar ubicación para mejor visibilidad de pedidos",
      locationDenied: "Acceso a ubicación denegado",
      placeBid: "Hacer Oferta",
      placingBid: "Ofertando...",
      bidAmount: "Monto de Oferta ($)",
      pickupTime: "Hora de Recogida",
      message: "Mensaje (opcional)",
      driverBids: "Ofertas de Conductores",
      acceptBid: "Aceptar Oferta",
      acceptingBid: "Aceptando...",
      markPickedUp: "Marcar como Recogido",
      markInTransit: "Marcar como En Tránsito",
      markDelivered: "Marcar como Entregado",
      pickingUp: "Recogiendo...",
      updating: "Actualizando...",
      completing: "Completando...",
      distanceFromPickup: "Distancia desde recogida",
      filterByCity: "Filtrar por Ciudad:",
      allCities: "Todas las Ciudades",
      clearFilter: "Limpiar Filtro",
      noActiveOrders: "No se encontraron pedidos activos",
      noAvailableBids: "No hay ofertas disponibles",
      noOrderHistory: "No hay historial de pedidos",
      noOrdersAvailable: "No hay pedidos disponibles",
    },
    reputation: {
      customerReputation: "Reputación del Cliente",
      driverReputation: "Reputación del Conductor",
      rating: "Calificación",
      deliveries: "Entregas",
      reviews: "Reseñas",
      memberSince: "Miembro Desde",
      reviewsGiven: "Reseñas Dadas",
      viewReviews: "Ver Reseñas",
      given: "Dado",
      verifyAccount: "Verificar Cuenta",
    },
    reviews: {
      submitReview: "Enviar Reseña",
      reviewDriver: "Reseñar Conductor",
      reviewCustomer: "Reseñar Cliente",
      reviewPlatform: "Reseñar Plataforma",
      overallRating: "Calificación General",
      professionalism: "Profesionalismo",
      communication: "Comunicación",
      timeliness: "Puntualidad",
      packageCondition: "Condición del Paquete",
      comment: "Comentario (Opcional)",
      shareExperience: "Comparte tu experiencia...",
      cancel: "Cancelar",
      submit: "Enviar Reseña",
      submitting: "Enviando...",
      provideRating: "Por favor proporciona una calificación general",
      orderReviews: "Reseñas del Pedido",
      noReviews: "Aún no hay reseñas para este pedido",
      reviewType: "Tipo de Reseña",
      reviewing: "Reseñando",
    },
    notifications: {
      notifications: "Notificaciones",
      noNotifications: "No hay notificaciones",
      newNotification: "Nueva notificación",
    },
    tracking: {
      orderTracking: "Seguimiento de Pedido",
      liveTracking: "Seguimiento en Vivo",
      currentStatus: "Estado Actual",
      currentLocation: "Ubicación Actual",
      timeline: "Cronograma",
      orderCreated: "Pedido Creado",
      bidAccepted: "Oferta Aceptada",
      packagePickedUp: "Paquete Recogido",
      locationHistory: "Historial de Ubicación",
      orderNumber: "Pedido #",
      close: "Cerrar",
      liveTrackingActive: "Seguimiento en Vivo Activo",
      connecting: "Conectando...",
      selectedLocation: "Ubicación Seleccionada",
      coordinates: "Coordenadas",
      copyCoordinates: "Copiar Coordenadas",
    },
    messages: {
      orderPublished:
        "¡Pedido publicado exitosamente! Esperando conductores en tu área.",
      bidPlaced: "¡Oferta realizada exitosamente!",
      bidAccepted: "¡Oferta aceptada exitosamente! Conductor notificado.",
      orderAccepted:
        "Tu pedido ha sido aceptado. El conductor lo recogerá pronto.",
      orderPickedUp: "¡Tu paquete ha sido recogido y está en camino!",
      orderInTransit: "¡Tu paquete está en tránsito y será entregado pronto!",
      orderCompleted: "¡Pedido completado exitosamente!",
      orderCancelled: "El pedido fue cancelado.",
      reviewSubmitted: "¡Reseña enviada exitosamente!",
      allFieldsRequired: "Todos los campos son requeridos",
      vehicleTypeRequired: "El tipo de vehículo es requerido para conductores",
      completeCaptcha: "Por favor completa el captcha",
      enterValidBid: "Ingresa un precio de oferta válido",
      fillRequiredFields: "Por favor llena todos los campos requeridos",
      connectionIssue:
        "Problema de conexión: Error al obtener usuario. Por favor intenta refrescar la página.",
      locationAccessFailed:
        "Error de acceso a ubicación. Por favor habilita los servicios de ubicación.",
      afterVerification:
        "Después de que el administrador verifique tu cuenta, por favor refresca esta página para ver el distintivo de verificación.",
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      confirm: "Confirmar",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      search: "Buscar",
      filter: "Filtrar",
      clear: "Limpiar",
      close: "Cerrar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      yes: "Sí",
      no: "No",
      optional: "Opcional",
      required: "Requerido",
      appName: "Matrix Heroes",
      subtitle: "Mercado P2P de Entregas",
      selectLanguage: "Seleccionar Idioma",
      vendorName: "Nombre del Vendedor",
      keyword: "Palabra Clave",
      lat: "Latitud",
      lng: "Longitud",
      radius: "Radio (km)",
      category: "Categoría",
      vendorId: "ID del Vendedor",
      itemName: "Nombre del Artículo",
      createVendor: "Crear Vendedor",
      yourLocation: "Tu Ubicación",
      driverCurrentLocation: "Ubicación Actual del Conductor",
      priceAsc: "Precio: Menor a Mayor",
      priceDesc: "Precio: Mayor a Menor",
      orderStatus: "Estado del Pedido",
      orderData: "Datos del Pedido",
      driverCoords: "Coordenadas del Conductor",
      costPerKm: "Costo por KM",
      waitingPerHour: "Espera por Hora",
      notifications: "Notificaciones",
      profile: "Perfil",
      menu: "Menú",
    },
    languages: {
      english: "Inglés",
      spanish: "Español",
      french: "Francés",
      chinese: "Chino",
      german: "Alemán",
      portuguese: "Portugués",
      arabic: "Árabe",
      russian: "Ruso",
      japanese: "Japonés",
      turkish: "Turco",
      urdu: "Urdu",
      hindi: "Hindi",
    },
  },
  fr: {
    auth: {
      signIn: "Se Connecter",
      signUp: "S'inscrire",
      createAccount: "Créer un Compte",
      email: "E-mail",
      password: "Mot de Passe",
      fullName: "Nom Complet",
      phoneNumber: "Numéro de Téléphone",
      primary_role: "Rôle",
      customer: "Client",
      driver: "Chauffeur",
      vehicleType: "Type de Véhicule",
      selectVehicleType: "Sélectionner le Type de Véhicule",
      walker: "Piétons",
      bicycle: "Vélo",
      bike: "Moto",
      car: "Voiture",
      van: "Camionnette",
      truck: "Camion",
      login: "Se Connecter",
      register: "Créer un Compte",
      logout: "Se Déconnecter",
      dontHaveAccount: "Vous n'avez pas de compte ?",
      alreadyHaveAccount: "Vous avez déjà un compte ?",
      loading: "Chargement...",
      verify: "Vérifier",
      verified: "Vérifié",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "Mes Commandes",
      createOrder: "Créer une Nouvelle Commande",
      cancel: "Annuler",
      orderTitle: "Titre de la Commande",
      description: "Description",
      packageDescription: "Description du Colis",
      packageWeight: "Poids du Colis (kg)",
      estimatedValue: "Valeur Estimée ($)",
      specialInstructions: "Instructions Spéciales",
      estimatedDelivery: "Date de Livraison Estimée",
      price: "Prix Proposé ($)",
      publishOrder: "Publier la Commande",
      publishingOrder: "Publication de la commande...",
      pickupLocation: "Lieu de Ramassage",
      deliveryLocation: "Lieu de Livraison",
      country: "Pays",
      city: "Ville",
      area: "Zone",
      street: "Rue",
      building: "Bâtiment",
      floor: "Étage",
      apartment: "Appartement",
      contactName: "Nom du Contact",
      selectCountry: "Sélectionner le Pays",
      enterCity: "Entrer la ville",
      enterArea: "Entrer la zone",
      enterStreet: "Entrer la rue",
      buildingNumber: "N° Bâtiment",
      aptNumber: "N° Appart",
      contactPerson: "Personne de contact",
      orderNumber: "Commande N°",
      pickup: "Ramassage",
      delivery: "Livraison",
      package: "Colis",
      weight: "Poids",
      value: "Valeur",
      instructions: "Instructions",
      trackOrder: "Suivre la Commande",
      viewReviews: "Voir les Avis",
      noOrders: "Aucune commande disponible",
      required: "Requis",
      optional: "Optionnel",
      orderTitleRequired: "Le titre de la commande est requis",
      priceRequired: "Le prix est requis",
      pickupCountryRequired: "Le pays de ramassage est requis",
      pickupCityRequired: "La ville de ramassage est requise",
      pickupContactRequired: "Le nom du contact de ramassage est requis",
      deliveryCountryRequired: "Le pays de livraison est requis",
      deliveryCityRequired: "La ville de livraison est requise",
      deliveryContactRequired: "Le nom du contact de livraison est requis",
      placeYourBid: "Placez votre offre",
      messageOptional: "Message (optionnel)",
      bidding: "Enchérissant...",
      pickingUp: "Ramassant...",
      updating: "Mise à jour...",
      completing: "Finalisation...",
      markAsPickedUp: "Marquer comme ramassé",
      markAsInTransit: "Marquer comme en transit",
      markAsDelivered: "Marquer comme livré",
      acceptedBid: "Offre acceptée",
      assignedDriver: "Chauffeur assigné",
      orderAccepted:
        "Votre commande a été acceptée. Le chauffeur la ramassera bientôt.",
      packagePickedUp: "Votre colis a été ramassé et est en route !",
      packageInTransit: "Votre colis est en transit et sera livré bientôt !",
      orderCompletedSuccessfully: "Commande terminée avec succès !",
      orderCancelled: "La commande a été annulée.",
      createNewOrder: "Créer une Nouvelle Commande",
      clearFilter: "Effacer le Filtre",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Offres en Attente",
      accepted: "Accepté",
      pickedUp: "Ramassé",
      inTransit: "En Transit",
      delivered: "Livré",
      courierDelivered: "Livré par le coursier",
      customerDelivered: "Livraison confirmée",
      completed: "Terminé",
      cancelled: "Annulé",
    },
    driver: {
      activeOrders: "Commandes Actives",
      availableBids: "Offres Disponibles",
      myHistory: "Mon Historique",
      updateLocation: "Mettre à Jour la Localisation",
      locationUpdated: "Localisation Mise à Jour",
      enableLocation:
        "Activer la localisation pour une meilleure visibilité des commandes",
      locationDenied: "Accès à la localisation refusé",
      placeBid: "Faire une Offre",
      placingBid: "Offre en cours...",
      bidAmount: "Montant de l'Offre ($)",
      pickupTime: "Heure de Ramassage",
      message: "Message (optionnel)",
      driverBids: "Offres des Chauffeurs",
      acceptBid: "Accepter l'Offre",
      acceptingBid: "Acceptation en cours...",
      markPickedUp: "Marquer comme Ramassé",
      markInTransit: "Marquer comme En Transit",
      markDelivered: "Marquer comme Livré",
      pickingUp: "Ramassage en cours...",
      updating: "Mise à jour...",
      completing: "Finalisation...",
      distanceFromPickup: "Distance depuis le ramassage",
      filterByCity: "Filtrer par Ville :",
      allCities: "Toutes les Villes",
      clearFilter: "Effacer le Filtre",
      noActiveOrders: "Aucune commande active trouvée",
      noAvailableBids: "Aucune offre disponible",
      noOrderHistory: "Aucun historique de commandes",
    },
    reputation: {
      customerReputation: "Réputation du Client",
      driverReputation: "Réputation du Chauffeur",
      rating: "Évaluation",
      deliveries: "Livraisons",
      reviews: "Avis",
      memberSince: "Membre Depuis",
      reviewsGiven: "Avis Donnés",
      viewReviews: "Voir les Avis",
      given: "Donné",
      verifyAccount: "Vérifier le Compte",
    },
    reviews: {
      submitReview: "Soumettre un Avis",
      reviewDriver: "Évaluer le Chauffeur",
      reviewCustomer: "Évaluer le Client",
      reviewPlatform: "Évaluer la Plateforme",
      overallRating: "Évaluation Globale",
      professionalism: "Professionnalisme",
      communication: "Communication",
      timeliness: "Ponctualité",
      packageCondition: "État du Colis",
      comment: "Commentaire (Optionnel)",
      shareExperience: "Partagez votre expérience...",
      cancel: "Annuler",
      submit: "Soumettre l'Avis",
      submitting: "Soumission en cours...",
      provideRating: "Veuillez fournir une évaluation globale",
      orderReviews: "Avis sur la Commande",
      noReviews: "Aucun avis pour cette commande encore",
      reviewType: "Type d'Avis",
      reviewing: "Évaluation",
    },
    notifications: {
      notifications: "Notifications",
      noNotifications: "Aucune notification",
      newNotification: "Nouvelle notification",
    },
    tracking: {
      orderTracking: "Suivi de Commande",
      liveTracking: "Suivi en Direct",
      currentStatus: "Statut Actuel",
      currentLocation: "Localisation Actuelle",
      timeline: "Chronologie",
      orderCreated: "Commande Créée",
      bidAccepted: "Offre Acceptée",
      packagePickedUp: "Colis Ramassé",
      locationHistory: "Historique des Localisations",
      close: "Fermer",
      liveTrackingActive: "Suivi en Direct Actif",
      connecting: "Connexion...",
      selectedLocation: "Localisation Sélectionnée",
      coordinates: "Coordonnées",
      copyCoordinates: "Copier les Coordonnées",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "Commande publiée avec succès ! En attente de chauffeurs dans votre région.",
      bidPlaced: "Offre réalisée avec succès !",
      bidAccepted: "Offre acceptée avec succès ! Chauffeur notifié.",
      orderAccepted:
        "Votre commande a été acceptée. Le chauffeur la ramassera bientôt.",
      orderPickedUp: "Votre colis a été ramassé et est en route !",
      orderInTransit: "Votre colis est en transit et sera livré bientôt !",
      orderCompleted: "Commande terminée avec succès !",
      orderCancelled: "La commande a été annulée.",
      reviewSubmitted: "Avis soumis avec succès !",
      allFieldsRequired: "Tous les champs sont requis",
      vehicleTypeRequired: "Le type de véhicule est requis pour les chauffeurs",
      completeCaptcha: "Veuillez compléter le captcha",
      enterValidBid: "Entrez un prix d'offre valide",
      fillRequiredFields: "Veuillez remplir tous les champs requis",
      connectionIssue:
        "Problème de connexion : Échec de récupération des informations utilisateur. Veuillez rafraîchir la page.",
      locationAccessFailed:
        "Échec d'accès à la localisation. Veuillez activer les services de localisation.",
      afterVerification:
        "Après que l'administrateur ait vérifié votre compte, veuillez rafraîchir cette page pour voir le badge de vérification.",
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      confirm: "Confirmer",
      cancel: "Annuler",
      save: "Sauvegarder",
      delete: "Supprimer",
      edit: "Modifier",
      search: "Rechercher",
      filter: "Filtrer",
      clear: "Effacer",
      close: "Fermer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      yes: "Oui",
      no: "Non",
      optional: "Optionnel",
      required: "Requis",
      appName: "Matrix Heroes",
      subtitle: "Marché P2P de Livraison",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "Anglais",
      spanish: "Espagnol",
      french: "Français",
      chinese: "Chinois",
      german: "Allemand",
      portuguese: "Portugais",
      arabic: "Arabe",
      russian: "Russe",
      japanese: "Japonais",
      turkish: "Turc",
      urdu: "Ourdou",
      hindi: "Hindi",
    },
  },
  zh: {
    auth: {
      signIn: "登录",
      signUp: "注册",
      createAccount: "创建账户",
      email: "电子邮件",
      password: "密码",
      fullName: "全名",
      phoneNumber: "电话号码",
      primary_role: "角色",
      customer: "客户",
      driver: "司机",
      vehicleType: "车辆类型",
      selectVehicleType: "选择车辆类型",
      walker: "步行者",
      bicycle: "自行车",
      bike: "摩托车",
      car: "汽车",
      van: "货车",
      truck: "卡车",
      login: "登录",
      register: "创建账户",
      logout: "登出",
      dontHaveAccount: "还没有账户？",
      alreadyHaveAccount: "已有账户？",
      loading: "加载中...",
      verify: "验证",
      verified: "已验证",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "我的订单",
      createOrder: "创建新订单",
      cancel: "取消",
      orderTitle: "订单标题",
      description: "描述",
      packageDescription: "包裹描述",
      packageWeight: "包裹重量 (kg)",
      estimatedValue: "预估价值 ($)",
      specialInstructions: "特殊说明",
      estimatedDelivery: "预估交付日期",
      price: "报价 ($)",
      publishOrder: "发布订单",
      publishingOrder: "发布订单中...",
      pickupLocation: "取货地点",
      deliveryLocation: "交付地点",
      country: "国家",
      city: "城市",
      area: "区域",
      street: "街道",
      building: "建筑",
      floor: "楼层",
      apartment: "公寓",
      contactName: "联系人姓名",
      selectCountry: "选择国家",
      enterCity: "输入城市",
      enterArea: "输入区域",
      enterStreet: "输入街道",
      buildingNumber: "建筑号",
      aptNumber: "公寓号",
      contactPerson: "联系人",
      orderNumber: "订单号",
      pickup: "取货",
      delivery: "交付",
      package: "包裹",
      weight: "重量",
      value: "价值",
      instructions: "说明",
      trackOrder: "跟踪订单",
      viewReviews: "查看评价",
      noOrders: "没有可用的订单",
      required: "必填",
      optional: "可选",
      orderTitleRequired: "订单标题为必填项",
      priceRequired: "价格为必填项",
      pickupCountryRequired: "取货国家为必填项",
      pickupCityRequired: "取货城市为必填项",
      pickupContactRequired: "取货联系人姓名为必填项",
      deliveryCountryRequired: "交付国家为必填项",
      deliveryCityRequired: "交付城市为必填项",
      deliveryContactRequired: "交付联系人姓名为必填项",
      placeYourBid: "下单",
      messageOptional: "消息（可选）",
      bidding: "竞标中...",
      pickingUp: "取货中...",
      updating: "更新中...",
      completing: "完成中...",
      markAsPickedUp: "标记为已取货",
      markAsInTransit: "标记为运输中",
      markAsDelivered: "标记为已交付",
      acceptedBid: "已接受报价",
      assignedDriver: "已分配司机",
      orderAccepted: "您的订单已被接受。司机将很快取货。",
      packagePickedUp: "您的包裹已被取货，正在运送中！",
      packageInTransit: "您的包裹正在运输中，即将交付！",
      orderCompletedSuccessfully: "订单完成成功！",
      orderCancelled: "订单已被取消。",
      createNewOrder: "创建新订单",
      clearFilter: "清除筛选",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "等待报价",
      accepted: "已接受",
      pickedUp: "已取货",
      inTransit: "运输中",
      delivered: "已交付",
      courierDelivered: "骑手已送达",
      customerDelivered: "已确认收货",
      completed: "已完成",
      cancelled: "已取消",
    },
    driver: {
      activeOrders: "活跃订单",
      availableBids: "可用报价",
      myHistory: "我的历史",
      updateLocation: "更新位置",
      locationUpdated: "位置已更新",
      enableLocation: "启用位置以获得更好的订单可见性",
      locationDenied: "位置访问被拒绝",
      placeBid: "出价",
      placingBid: "出价中...",
      bidAmount: "出价金额 ($)",
      pickupTime: "取货时间",
      message: "消息（可选）",
      driverBids: "司机报价",
      acceptBid: "接受报价",
      acceptingBid: "接受中...",
      markPickedUp: "标记为已取货",
      markInTransit: "标记为运输中",
      markDelivered: "标记为已交付",
      pickingUp: "取货中...",
      updating: "更新中...",
      completing: "完成中...",
      distanceFromPickup: "距取货点的距离",
      filterByCity: "按城市筛选：",
      allCities: "所有城市",
      clearFilter: "清除筛选",
      noActiveOrders: "未找到活跃订单",
      noAvailableBids: "没有可用报价",
      noOrderHistory: "没有订单历史",
    },
    reputation: {
      customerReputation: "客户声誉",
      driverReputation: "司机声誉",
      rating: "评分",
      deliveries: "交付",
      reviews: "评价",
      memberSince: "注册时间",
      reviewsGiven: "已给评价",
      viewReviews: "查看评价",
      given: "已给",
      verifyAccount: "验证账户",
    },
    reviews: {
      submitReview: "提交评价",
      reviewDriver: "评价司机",
      reviewCustomer: "评价客户",
      reviewPlatform: "评价平台",
      overallRating: "总体评分",
      professionalism: "专业性",
      communication: "沟通",
      timeliness: "及时性",
      packageCondition: "包裹状况",
      comment: "评论（可选）",
      shareExperience: "分享您的体验...",
      cancel: "取消",
      submit: "提交评价",
      submitting: "提交中...",
      provideRating: "请提供总体评分",
      orderReviews: "订单评价",
      noReviews: "此订单暂无评价",
      reviewType: "评价类型",
      reviewing: "评价中",
    },
    notifications: {
      notifications: "通知",
      noNotifications: "没有通知",
      newNotification: "新通知",
    },
    tracking: {
      orderTracking: "订单跟踪",
      liveTracking: "实时跟踪",
      currentStatus: "当前状态",
      currentLocation: "当前位置",
      timeline: "时间线",
      orderCreated: "订单已创建",
      bidAccepted: "报价已接受",
      packagePickedUp: "包裹已取货",
      locationHistory: "位置历史",
      close: "关闭",
      liveTrackingActive: "实时跟踪激活",
      connecting: "连接中...",
      selectedLocation: "选定位置",
      coordinates: "坐标",
      copyCoordinates: "复制坐标",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished: "订单发布成功！等待您所在地区的司机。",
      bidPlaced: "报价成功！",
      bidAccepted: "报价接受成功！司机已收到通知。",
      orderAccepted: "您的订单已被接受。司机将很快取货。",
      orderPickedUp: "您的包裹已被取货，正在运送中！",
      orderInTransit: "您的包裹正在运输中，即将交付！",
      orderCompleted: "订单完成成功！",
      orderCancelled: "订单已被取消。",
      reviewSubmitted: "评价提交成功！",
      allFieldsRequired: "所有字段均为必填项",
      vehicleTypeRequired: "司机需要选择车辆类型",
      completeCaptcha: "请完成验证码",
      enterValidBid: "请输入有效的报价价格",
      fillRequiredFields: "请填写所有必填字段",
      connectionIssue: "连接问题：获取用户信息失败。请刷新页面。",
      locationAccessFailed: "位置访问失败。请启用位置服务。",
      afterVerification: "管理员验证您的账户后，请刷新此页面查看验证徽章。",
    },
    common: {
      loading: "加载中...",
      error: "错误",
      success: "成功",
      confirm: "确认",
      cancel: "取消",
      save: "保存",
      delete: "删除",
      edit: "编辑",
      search: "搜索",
      filter: "筛选",
      clear: "清除",
      close: "关闭",
      back: "返回",
      next: "下一步",
      previous: "上一步",
      yes: "是",
      no: "否",
      optional: "可选",
      required: "必填",
      appName: "Matrix Heroes",
      subtitle: "P2P 交付市场",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "英语",
      spanish: "西班牙语",
      french: "法语",
      chinese: "中文",
      german: "德语",
      portuguese: "葡萄牙语",
      arabic: "阿拉伯语",
      russian: "俄语",
      japanese: "日语",
      turkish: "土耳其语",
      urdu: "乌尔都语",
      hindi: "印地语",
    },
  },
  de: {
    auth: {
      signIn: "Anmelden",
      signUp: "Registrieren",
      createAccount: "Konto Erstellen",
      email: "E-Mail",
      password: "Passwort",
      fullName: "Vollständiger Name",
      phoneNumber: "Telefonnummer",
      primary_role: "Rolle",
      customer: "Kunde",
      driver: "Fahrer",
      vehicleType: "Fahrzeugtyp",
      selectVehicleType: "Fahrzeugtyp Auswählen",
      walker: "Fußgänger",
      bicycle: "Fahrrad",
      bike: "Motorrad",
      car: "Auto",
      van: "Transporter",
      truck: "LKW",
      login: "Anmelden",
      register: "Konto Erstellen",
      logout: "Abmelden",
      dontHaveAccount: "Haben Sie noch kein Konto?",
      alreadyHaveAccount: "Haben Sie bereits ein Konto?",
      loading: "Laden...",
      verify: "Verifizieren",
      verified: "Verifiziert",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "Meine Bestellungen",
      createOrder: "Neue Bestellung Erstellen",
      cancel: "Abbrechen",
      orderTitle: "Bestellungstitel",
      description: "Beschreibung",
      packageDescription: "Paketbeschreibung",
      packageWeight: "Paketgewicht (kg)",
      estimatedValue: "Geschätzter Wert ($)",
      specialInstructions: "Besondere Anweisungen",
      estimatedDelivery: "Geschätztes Lieferdatum",
      price: "Angebotener Preis ($)",
      publishOrder: "Bestellung Veröffentlichen",
      publishingOrder: "Bestellung wird veröffentlicht...",
      pickupLocation: "Abholort",
      deliveryLocation: "Lieferort",
      country: "Land",
      city: "Stadt",
      area: "Bereich",
      street: "Straße",
      building: "Gebäude",
      floor: "Etage",
      apartment: "Wohnung",
      contactName: "Kontaktname",
      selectCountry: "Land Auswählen",
      enterCity: "Stadt eingeben",
      enterArea: "Bereich eingeben",
      enterStreet: "Straße eingeben",
      buildingNumber: "Gebäude Nr.",
      aptNumber: "Wohnung Nr.",
      contactPerson: "Kontaktperson",
      orderNumber: "Bestellung Nr.",
      pickup: "Abholung",
      delivery: "Lieferung",
      package: "Paket",
      weight: "Gewicht",
      value: "Wert",
      instructions: "Anweisungen",
      trackOrder: "Bestellung Verfolgen",
      viewReviews: "Bewertungen Ansehen",
      noOrders: "Keine Bestellungen verfügbar",
      required: "Erforderlich",
      optional: "Optional",
      orderTitleRequired: "Bestellungstitel ist erforderlich",
      priceRequired: "Preis ist erforderlich",
      pickupCountryRequired: "Abholland ist erforderlich",
      pickupCityRequired: "Abholstadt ist erforderlich",
      pickupContactRequired: "Abholkontaktname ist erforderlich",
      deliveryCountryRequired: "Lieferland ist erforderlich",
      deliveryCityRequired: "Lieferstadt ist erforderlich",
      deliveryContactRequired: "Lieferkontaktname ist erforderlich",
      placeYourBid: "Geben Sie Ihr Gebot ab",
      messageOptional: "Nachricht (optional)",
      bidding: "Biete...",
      pickingUp: "Hole ab...",
      updating: "Aktualisiere...",
      completing: "Schließe ab...",
      markAsPickedUp: "Als abgeholt markieren",
      markAsInTransit: "Als unterwegs markieren",
      markAsDelivered: "Als geliefert markieren",
      acceptedBid: "Akzeptiertes Gebot",
      assignedDriver: "Zugewiesener Fahrer",
      orderAccepted:
        "Ihre Bestellung wurde akzeptiert. Der Fahrer wird sie bald abholen.",
      packagePickedUp: "Ihr Paket wurde abgeholt und ist unterwegs!",
      packageInTransit: "Ihr Paket ist unterwegs und wird bald geliefert!",
      orderCompletedSuccessfully: "Bestellung erfolgreich abgeschlossen!",
      orderCancelled: "Die Bestellung wurde storniert.",
      createNewOrder: "Neue Bestellung Erstellen",
      clearFilter: "Filter Löschen",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Ausstehende Angebote",
      accepted: "Akzeptiert",
      pickedUp: "Abgeholt",
      inTransit: "Unterwegs",
      delivered: "Geliefert",
      courierDelivered: "Vom Kurier zugestellt",
      customerDelivered: "Zustellung bestätigt",
      completed: "Abgeschlossen",
      cancelled: "Storniert",
    },
    driver: {
      activeOrders: "Aktive Bestellungen",
      availableBids: "Verfügbare Angebote",
      myHistory: "Mein Verlauf",
      updateLocation: "Standort Aktualisieren",
      locationUpdated: "Standort Aktualisiert",
      enableLocation: "Standort aktivieren für bessere Bestellungssichtbarkeit",
      locationDenied: "Standortzugriff verweigert",
      placeBid: "Angebot Abgeben",
      placingBid: "Angebot wird abgegeben...",
      bidAmount: "Angebotsbetrag ($)",
      pickupTime: "Abholzeit",
      message: "Nachricht (optional)",
      driverBids: "Fahrerangebote",
      acceptBid: "Angebot Akzeptieren",
      acceptingBid: "Wird akzeptiert...",
      markPickedUp: "Als Abgeholt Markieren",
      markInTransit: "Als Unterwegs Markieren",
      markDelivered: "Als Geliefert Markieren",
      pickingUp: "Wird abgeholt...",
      updating: "Wird aktualisiert...",
      completing: "Wird abgeschlossen...",
      distanceFromPickup: "Entfernung von Abholort",
      filterByCity: "Nach Stadt Filtern:",
      allCities: "Alle Städte",
      clearFilter: "Filter Löschen",
      noActiveOrders: "Keine aktiven Bestellungen gefunden",
      noAvailableBids: "Keine verfügbaren Angebote",
      noOrderHistory: "Kein Bestellungsverlauf",
    },
    reputation: {
      customerReputation: "Kundenruf",
      driverReputation: "Fahrerruf",
      rating: "Bewertung",
      deliveries: "Lieferungen",
      reviews: "Bewertungen",
      memberSince: "Mitglied Seit",
      reviewsGiven: "Abgegebene Bewertungen",
      viewReviews: "Bewertungen Ansehen",
      given: "Abgegeben",
      verifyAccount: "Konto Verifizieren",
    },
    reviews: {
      submitReview: "Bewertung Abgeben",
      reviewDriver: "Fahrer Bewerten",
      reviewCustomer: "Kunden Bewerten",
      reviewPlatform: "Plattform Bewerten",
      overallRating: "Gesamtbewertung",
      professionalism: "Professionalität",
      communication: "Kommunikation",
      timeliness: "Pünktlichkeit",
      packageCondition: "Paketzustand",
      comment: "Kommentar (Optional)",
      shareExperience: "Teilen Sie Ihre Erfahrung...",
      cancel: "Abbrechen",
      submit: "Bewertung Abgeben",
      submitting: "Wird übermittelt...",
      provideRating: "Bitte geben Sie eine Gesamtbewertung ab",
      orderReviews: "Bestellungsbewertungen",
      noReviews: "Noch keine Bewertungen für diese Bestellung",
      reviewType: "Bewertungstyp",
      reviewing: "Bewertung",
    },
    notifications: {
      notifications: "Benachrichtigungen",
      noNotifications: "Keine Benachrichtigungen",
      newNotification: "Neue Benachrichtigung",
    },
    tracking: {
      orderTracking: "Bestellungsverfolgung",
      liveTracking: "Live-Verfolgung",
      currentStatus: "Aktueller Status",
      currentLocation: "Aktueller Standort",
      timeline: "Zeitachse",
      orderCreated: "Bestellung Erstellt",
      bidAccepted: "Angebot Akzeptiert",
      packagePickedUp: "Paket Abgeholt",
      locationHistory: "Standortverlauf",
      close: "Schließen",
      liveTrackingActive: "Live-Verfolgung Aktiv",
      connecting: "Verbindung wird hergestellt...",
      selectedLocation: "Ausgewählter Standort",
      coordinates: "Koordinaten",
      copyCoordinates: "Koordinaten Kopieren",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "Bestellung erfolgreich veröffentlicht! Warte auf Fahrer in Ihrer Region.",
      bidPlaced: "Angebot erfolgreich abgegeben!",
      bidAccepted: "Angebot erfolgreich akzeptiert! Fahrer benachrichtigt.",
      orderAccepted:
        "Ihre Bestellung wurde akzeptiert. Der Fahrer wird sie bald abholen.",
      orderPickedUp: "Ihr Paket wurde abgeholt und ist unterwegs!",
      orderInTransit: "Ihr Paket ist unterwegs und wird bald geliefert!",
      orderCompleted: "Bestellung erfolgreich abgeschlossen!",
      orderCancelled: "Die Bestellung wurde storniert.",
      reviewSubmitted: "Bewertung erfolgreich übermittelt!",
      allFieldsRequired: "Alle Felder sind erforderlich",
      vehicleTypeRequired: "Fahrzeugtyp ist für Fahrer erforderlich",
      completeCaptcha: "Bitte vervollständigen Sie das Captcha",
      enterValidBid: "Geben Sie einen gültigen Angebotspreis ein",
      fillRequiredFields: "Bitte füllen Sie alle erforderlichen Felder aus",
      connectionIssue:
        "Verbindungsproblem: Fehler beim Abrufen der Benutzerinformationen. Bitte aktualisieren Sie die Seite.",
      locationAccessFailed:
        "Standortzugriff fehlgeschlagen. Bitte aktivieren Sie die Standortdienste.",
      afterVerification:
        "Nachdem der Administrator Ihr Konto verifiziert hat, aktualisieren Sie bitte diese Seite, um das Verifizierungsabzeichen zu sehen.",
    },
    common: {
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      confirm: "Bestätigen",
      cancel: "Abbrechen",
      save: "Speichern",
      delete: "Löschen",
      edit: "Bearbeiten",
      search: "Suchen",
      filter: "Filtern",
      clear: "Löschen",
      close: "Schließen",
      back: "Zurück",
      next: "Weiter",
      previous: "Vorherige",
      yes: "Ja",
      no: "Nein",
      optional: "Optional",
      required: "Erforderlich",
      appName: "Matrix Heroes",
      subtitle: "P2P Liefermarkt",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "Englisch",
      spanish: "Spanisch",
      french: "Französisch",
      chinese: "Chinesisch",
      german: "Deutsch",
      portuguese: "Portugiesisch",
      arabic: "Arabisch",
      russian: "Russisch",
      japanese: "Japanisch",
      turkish: "Türkisch",
      urdu: "Urdu",
      hindi: "Hindi",
    },
  },
  pt: {
    auth: {
      signIn: "Entrar",
      signUp: "Cadastrar",
      createAccount: "Criar Conta",
      email: "E-mail",
      password: "Senha",
      fullName: "Nome Completo",
      phoneNumber: "Número de Telefone",
      primary_role: "Função",
      customer: "Cliente",
      driver: "Motorista",
      vehicleType: "Tipo de Veículo",
      selectVehicleType: "Selecionar Tipo de Veículo",
      walker: "Pedestre",
      bicycle: "Bicicleta",
      bike: "Moto",
      car: "Carro",
      van: "Van",
      truck: "Caminhão",
      login: "Entrar",
      register: "Criar Conta",
      logout: "Sair",
      dontHaveAccount: "Não tem uma conta?",
      alreadyHaveAccount: "Já tem uma conta?",
      loading: "Carregando...",
      verify: "Verificar",
      verified: "Verificado",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "Meus Pedidos",
      createOrder: "Criar Novo Pedido",
      cancel: "Cancelar",
      orderTitle: "Título do Pedido",
      description: "Descrição",
      packageDescription: "Descrição do Pacote",
      packageWeight: "Peso do Pacote (kg)",
      estimatedValue: "Valor Estimado ($)",
      specialInstructions: "Instruções Especiais",
      estimatedDelivery: "Data de Entrega Estimada",
      price: "Preço Oferecido ($)",
      publishOrder: "Publicar Pedido",
      publishingOrder: "Publicando pedido...",
      pickupLocation: "Local de Coleta",
      deliveryLocation: "Local de Entrega",
      country: "País",
      city: "Cidade",
      area: "Área",
      street: "Rua",
      building: "Prédio",
      floor: "Andar",
      apartment: "Apartamento",
      contactName: "Nome do Contato",
      selectCountry: "Selecionar País",
      enterCity: "Digite a cidade",
      enterArea: "Digite a área",
      enterStreet: "Digite a rua",
      buildingNumber: "N° Prédio",
      aptNumber: "N° Apt",
      contactPerson: "Pessoa de contato",
      orderNumber: "Pedido N°",
      pickup: "Coleta",
      delivery: "Entrega",
      package: "Pacote",
      weight: "Peso",
      value: "Valor",
      instructions: "Instruções",
      trackOrder: "Rastrear Pedido",
      viewReviews: "Ver Avaliações",
      noOrders: "Nenhum pedido disponível",
      required: "Obrigatório",
      optional: "Opcional",
      orderTitleRequired: "Título do pedido é obrigatório",
      priceRequired: "Preço é obrigatório",
      pickupCountryRequired: "País de coleta é obrigatório",
      pickupCityRequired: "Cidade de coleta é obrigatória",
      pickupContactRequired: "Nome do contato de coleta é obrigatório",
      deliveryCountryRequired: "País de entrega é obrigatório",
      deliveryCityRequired: "Cidade de entrega é obrigatória",
      deliveryContactRequired: "Nome do contato de entrega é obrigatório",
      placeYourBid: "Faça sua oferta",
      messageOptional: "Mensagem (opcional)",
      bidding: "Fazendo oferta...",
      pickingUp: "Coletando...",
      updating: "Atualizando...",
      completing: "Finalizando...",
      markAsPickedUp: "Marcar como coletado",
      markAsInTransit: "Marcar como em trânsito",
      markAsDelivered: "Marcar como entregue",
      acceptedBid: "Oferta aceita",
      assignedDriver: "Motorista atribuído",
      orderAccepted:
        "Seu pedido foi aceito. O motorista irá coletá-lo em breve.",
      packagePickedUp: "Seu pacote foi coletado e está a caminho!",
      packageInTransit: "Seu pacote está em trânsito e será entregue em breve!",
      orderCompletedSuccessfully: "Pedido concluído com sucesso!",
      orderCancelled: "O pedido foi cancelado.",
      createNewOrder: "Criar Novo Pedido",
      clearFilter: "Limpar Filtro",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Ofertas Pendentes",
      accepted: "Aceito",
      pickedUp: "Coletado",
      inTransit: "Em Trânsito",
      delivered: "Entregue",
      courierDelivered: "Entregue pelo entregador",
      customerDelivered: "Entrega confirmada",
      completed: "Concluído",
      cancelled: "Cancelado",
    },
    driver: {
      activeOrders: "Pedidos Ativos",
      availableBids: "Ofertas Disponíveis",
      myHistory: "Meu Histórico",
      updateLocation: "Atualizar Localização",
      locationUpdated: "Localização Atualizada",
      enableLocation:
        "Habilitar localização para melhor visibilidade de pedidos",
      locationDenied: "Acesso à localização negado",
      placeBid: "Fazer Oferta",
      placingBid: "Fazendo oferta...",
      bidAmount: "Valor da Oferta ($)",
      pickupTime: "Horário de Coleta",
      message: "Mensagem (opcional)",
      driverBids: "Ofertas de Motoristas",
      acceptBid: "Aceitar Oferta",
      acceptingBid: "Aceitando...",
      markPickedUp: "Marcar como Coletado",
      markInTransit: "Marcar como Em Trânsito",
      markDelivered: "Marcar como Entregue",
      pickingUp: "Coletando...",
      updating: "Atualizando...",
      completing: "Finalizando...",
      distanceFromPickup: "Distância da coleta",
      filterByCity: "Filtrar por Cidade:",
      allCities: "Todas as Cidades",
      clearFilter: "Limpar Filtro",
      noActiveOrders: "Nenhum pedido ativo encontrado",
      noAvailableBids: "Nenhuma oferta disponível",
      noOrderHistory: "Nenhum histórico de pedidos",
    },
    reputation: {
      customerReputation: "Reputação do Cliente",
      driverReputation: "Reputação do Motorista",
      rating: "Avaliação",
      deliveries: "Entregas",
      reviews: "Avaliações",
      memberSince: "Membro Desde",
      reviewsGiven: "Avaliações Dadas",
      viewReviews: "Ver Avaliações",
      given: "Dado",
      verifyAccount: "Verificar Conta",
    },
    reviews: {
      submitReview: "Enviar Avaliação",
      reviewDriver: "Avaliar Motorista",
      reviewCustomer: "Avaliar Cliente",
      reviewPlatform: "Avaliar Plataforma",
      overallRating: "Avaliação Geral",
      professionalism: "Profissionalismo",
      communication: "Comunicação",
      timeliness: "Pontualidade",
      packageCondition: "Condição do Pacote",
      comment: "Comentário (Opcional)",
      shareExperience: "Compartilhe sua experiência...",
      cancel: "Cancelar",
      submit: "Enviar Avaliação",
      submitting: "Enviando...",
      provideRating: "Por favor forneça uma avaliação geral",
      orderReviews: "Avaliações do Pedido",
      noReviews: "Ainda não há avaliações para este pedido",
      reviewType: "Tipo de Avaliação",
      reviewing: "Avaliando",
    },
    notifications: {
      notifications: "Notificações",
      noNotifications: "Nenhuma notificação",
      newNotification: "Nova notificação",
    },
    tracking: {
      orderTracking: "Rastreamento de Pedido",
      liveTracking: "Rastreamento ao Vivo",
      currentStatus: "Status Atual",
      currentLocation: "Localização Atual",
      timeline: "Cronograma",
      orderCreated: "Pedido Criado",
      bidAccepted: "Oferta Aceita",
      packagePickedUp: "Pacote Coletado",
      locationHistory: "Histórico de Localização",
      close: "Fechar",
      liveTrackingActive: "Rastreamento ao Vivo Ativo",
      connecting: "Conectando...",
      selectedLocation: "Localização Selecionada",
      coordinates: "Coordenadas",
      copyCoordinates: "Copiar Coordenadas",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "Pedido publicado com sucesso! Aguardando motoristas em sua região.",
      bidPlaced: "Oferta feita com sucesso!",
      bidAccepted: "Oferta aceita com sucesso! Motorista notificado.",
      orderAccepted:
        "Seu pedido foi aceito. O motorista irá coletá-lo em breve.",
      orderPickedUp: "Seu pacote foi coletado e está a caminho!",
      orderInTransit: "Seu pacote está em trânsito e será entregue em breve!",
      orderCompleted: "Pedido concluído com sucesso!",
      orderCancelled: "O pedido foi cancelado.",
      reviewSubmitted: "Avaliação enviada com sucesso!",
      allFieldsRequired: "Todos os campos são obrigatórios",
      vehicleTypeRequired: "Tipo de veículo é obrigatório para motoristas",
      completeCaptcha: "Por favor complete o captcha",
      enterValidBid: "Digite um preço de oferta válido",
      fillRequiredFields: "Por favor preencha todos os campos obrigatórios",
      connectionIssue:
        "Problema de conexão: Falha ao obter informações do usuário. Por favor atualize a página.",
      locationAccessFailed:
        "Falha no acesso à localização. Por favor ative os serviços de localização.",
      afterVerification:
        "Depois que o administrador verificar sua conta, por favor atualize esta página para ver o distintivo de verificação.",
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      confirm: "Confirmar",
      cancel: "Cancelar",
      save: "Salvar",
      delete: "Excluir",
      edit: "Editar",
      search: "Buscar",
      filter: "Filtrar",
      clear: "Limpar",
      close: "Fechar",
      back: "Voltar",
      next: "Próximo",
      previous: "Anterior",
      yes: "Sim",
      no: "Não",
      optional: "Opcional",
      required: "Obrigatório",
      appName: "Matrix Heroes",
      subtitle: "Mercado P2P de Entregas",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "Inglês",
      spanish: "Espanhol",
      french: "Francês",
      chinese: "Chinês",
      german: "Alemão",
      portuguese: "Português",
      arabic: "Árabe",
      russian: "Russo",
      japanese: "Japonês",
      turkish: "Turco",
      urdu: "Urdu",
      hindi: "Hindi",
    },
  },
  ru: {
    auth: {
      signIn: "Войти",
      signUp: "Регистрация",
      createAccount: "Создать аккаунт",
      email: "Электронная почта",
      password: "Пароль",
      fullName: "Полное имя",
      phoneNumber: "Номер телефона",
      primary_role: "Роль",
      customer: "Клиент",
      driver: "Водитель",
      vehicleType: "Тип транспортного средства",
      selectVehicleType: "Выберите тип транспортного средства",
      walker: "Пешеход",
      bicycle: "Велосипед",
      bike: "Мотоцикл",
      car: "Автомобиль",
      van: "Фургон",
      truck: "Грузовик",
      login: "Войти",
      register: "Создать аккаунт",
      logout: "Выйти",
      dontHaveAccount: "У вас нет аккаунта?",
      alreadyHaveAccount: "У вас уже есть аккаунт?",
      loading: "Загрузка...",
      verify: "Проверить",
      verified: "Проверено",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "Мои заказы",
      createOrder: "Создать новый заказ",
      cancel: "Отмена",
      orderTitle: "Название заказа",
      description: "Описание",
      packageDescription: "Описание посылки",
      packageWeight: "Вес посылки (кг)",
      estimatedValue: "Ориентировочная стоимость ($)",
      specialInstructions: "Особые указания",
      estimatedDelivery: "Ориентировочная дата доставки",
      price: "Предлагаемая цена ($)",
      publishOrder: "Опубликовать заказ",
      publishingOrder: "Публикация заказа...",
      pickupLocation: "Место получения",
      deliveryLocation: "Место доставки",
      country: "Страна",
      city: "Город",
      area: "Район",
      street: "Улица",
      building: "Здание",
      floor: "Этаж",
      apartment: "Квартира",
      contactName: "Имя контактного лица",
      selectCountry: "Выберите страну",
      enterCity: "Введите город",
      enterArea: "Введите район",
      enterStreet: "Введите улицу",
      buildingNumber: "Номер здания",
      aptNumber: "Номер квартиры",
      contactPerson: "Контактное лицо",
      orderNumber: "Заказ №",
      pickup: "Получение",
      delivery: "Доставка",
      package: "Посылка",
      weight: "Вес",
      value: "Стоимость",
      instructions: "Указания",
      trackOrder: "Отследить заказ",
      viewReviews: "Посмотреть отзывы",
      noOrders: "Нет доступных заказов",
      required: "Обязательно",
      optional: "Необязательно",
      orderTitleRequired: "Название заказа обязательно",
      priceRequired: "Цена обязательна",
      pickupCountryRequired: "Страна получения обязательна",
      pickupCityRequired: "Город получения обязателен",
      pickupContactRequired: "Имя контактного лица для получения обязательно",
      deliveryCountryRequired: "Страна доставки обязательна",
      deliveryCityRequired: "Город доставки обязателен",
      deliveryContactRequired: "Имя контактного лица для доставки обязательно",
      placeYourBid: "Сделайте свое предложение",
      messageOptional: "Сообщение (необязательно)",
      bidding: "Делаю предложение...",
      pickingUp: "Получаю...",
      updating: "Обновляю...",
      completing: "Завершаю...",
      markAsPickedUp: "Отметить как полученный",
      markAsInTransit: "Отметить как в пути",
      markAsDelivered: "Отметить как доставленный",
      acceptedBid: "Принятое предложение",
      assignedDriver: "Назначенный водитель",
      orderAccepted: "Ваш заказ принят. Водитель скоро заберет его.",
      packagePickedUp: "Ваша посылка получена и находится в пути!",
      packageInTransit: "Ваша посылка в пути и скоро будет доставлена!",
      orderCompletedSuccessfully: "Заказ успешно завершен!",
      orderCancelled: "Заказ был отменен.",
      createNewOrder: "Создать Новый Заказ",
      clearFilter: "Очистить Фильтр",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Ожидают предложений",
      accepted: "Принят",
      pickedUp: "Получен",
      inTransit: "В пути",
      delivered: "Доставлен",
      courierDelivered: "Доставлено курьером",
      customerDelivered: "Доставка подтверждена",
      completed: "Завершено",
      cancelled: "Отменен",
    },
    driver: {
      activeOrders: "Активные заказы",
      availableBids: "Доступные предложения",
      myHistory: "Моя история",
      updateLocation: "Обновить местоположение",
      locationUpdated: "Местоположение обновлено",
      enableLocation: "Включите местоположение для лучшей видимости заказов",
      locationDenied: "Доступ к местоположению запрещен",
      placeBid: "Сделать предложение",
      placingBid: "Делаю предложение...",
      bidAmount: "Сумма предложения ($)",
      pickupTime: "Время получения",
      message: "Сообщение (необязательно)",
      driverBids: "Предложения водителей",
      acceptBid: "Принять предложение",
      acceptingBid: "Принимаю...",
      markPickedUp: "Отметить как полученный",
      markInTransit: "Отметить как в пути",
      markDelivered: "Отметить как доставленный",
      pickingUp: "Получаю...",
      updating: "Обновляю...",
      completing: "Завершаю...",
      distanceFromPickup: "Расстояние от места получения",
      filterByCity: "Фильтр по городу:",
      allCities: "Все города",
      clearFilter: "Очистить фильтр",
      noActiveOrders: "Активных заказов не найдено",
      noAvailableBids: "Нет доступных предложений",
      noOrderHistory: "Нет истории заказов",
    },
    reputation: {
      customerReputation: "Репутация клиента",
      driverReputation: "Репутация водителя",
      rating: "Рейтинг",
      deliveries: "Доставки",
      reviews: "Отзывы",
      memberSince: "Участник с",
      reviewsGiven: "Отданные отзывы",
      viewReviews: "Посмотреть отзывы",
      given: "Отдан",
      verifyAccount: "Проверить аккаунт",
    },
    reviews: {
      submitReview: "Отправить отзыв",
      reviewDriver: "Оценить водителя",
      reviewCustomer: "Оценить клиента",
      reviewPlatform: "Оценить платформу",
      overallRating: "Общий рейтинг",
      professionalism: "Профессионализм",
      communication: "Общение",
      timeliness: "Своевременность",
      packageCondition: "Состояние посылки",
      comment: "Комментарий (необязательно)",
      shareExperience: "Поделитесь своим опытом...",
      cancel: "Отмена",
      submit: "Отправить отзыв",
      submitting: "Отправляю...",
      provideRating: "Пожалуйста, предоставьте общий рейтинг",
      orderReviews: "Отзывы о заказе",
      noReviews: "Пока нет отзывов об этом заказе",
      reviewType: "Тип отзыва",
      reviewing: "Оцениваю",
    },
    notifications: {
      notifications: "Уведомления",
      noNotifications: "Нет уведомлений",
      newNotification: "Новое уведомление",
    },
    tracking: {
      orderTracking: "Отслеживание заказа",
      liveTracking: "Живое отслеживание",
      currentStatus: "Текущий статус",
      currentLocation: "Текущее местоположение",
      timeline: "Хронология",
      orderCreated: "Заказ создан",
      bidAccepted: "Предложение принято",
      packagePickedUp: "Посылка получена",
      locationHistory: "История местоположения",
      close: "Закрыть",
      liveTrackingActive: "Живое отслеживание активно",
      connecting: "Подключение...",
      selectedLocation: "Выбранное местоположение",
      coordinates: "Координаты",
      copyCoordinates: "Копировать координаты",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "Заказ успешно опубликован! Ожидаем водителей в вашем регионе.",
      bidPlaced: "Предложение успешно сделано!",
      bidAccepted: "Предложение успешно принято! Водитель уведомлен.",
      orderAccepted: "Ваш заказ принят. Водитель скоро заберет его.",
      orderPickedUp: "Ваша посылка получена и находится в пути!",
      orderInTransit: "Ваша посылка в пути и скоро будет доставлена!",
      orderCompleted: "Заказ успешно завершен!",
      orderCancelled: "Заказ был отменен.",
      reviewSubmitted: "Отзыв успешно отправлен!",
      allFieldsRequired: "Все поля обязательны",
      vehicleTypeRequired:
        "Тип транспортного средства обязателен для водителей",
      completeCaptcha: "Пожалуйста, заполните капчу",
      enterValidBid: "Введите действительную сумму предложения",
      fillRequiredFields: "Пожалуйста, заполните все обязательные поля",
      connectionIssue:
        "Проблема с подключением: Не удалось получить информацию о пользователе. Пожалуйста, обновите страницу.",
      locationAccessFailed:
        "Не удалось получить доступ к местоположению. Пожалуйста, включите службы геолокации.",
      afterVerification:
        "После того, как администратор проверит ваш аккаунт, пожалуйста, обновите эту страницу, чтобы увидеть значок проверки.",
    },
    common: {
      loading: "Загрузка...",
      error: "Ошибка",
      success: "Успех",
      confirm: "Подтвердить",
      cancel: "Отмена",
      save: "Сохранить",
      delete: "Удалить",
      edit: "Редактировать",
      search: "Поиск",
      filter: "Фильтр",
      clear: "Очистить",
      close: "Закрыть",
      back: "Назад",
      next: "Далее",
      previous: "Предыдущий",
      yes: "Да",
      no: "Нет",
      optional: "Необязательно",
      required: "Обязательно",
      appName: "Matrix Heroes",
      subtitle: "P2P рынок доставки",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "Английский",
      spanish: "Испанский",
      french: "Французский",
      chinese: "Китайский",
      german: "Немецкий",
      portuguese: "Португальский",
      arabic: "Арабский",
      russian: "Русский",
      japanese: "Японский",
      turkish: "Турецкий",
      urdu: "Урду",
      hindi: "Хинди",
    },
  },
  ja: {
    auth: {
      signIn: "サインイン",
      signUp: "サインアップ",
      createAccount: "アカウント作成",
      email: "メールアドレス",
      password: "パスワード",
      fullName: "フルネーム",
      phoneNumber: "電話番号",
      primary_role: "役割",
      customer: "顧客",
      driver: "ドライバー",
      vehicleType: "車両タイプ",
      selectVehicleType: "車両タイプを選択",
      walker: "徒歩",
      bicycle: "自転車",
      bike: "バイク",
      car: "車",
      van: "バン",
      truck: "トラック",
      login: "サインイン",
      register: "アカウント作成",
      logout: "ログアウト",
      dontHaveAccount: "アカウントをお持ちですか？",
      alreadyHaveAccount: "すでにアカウントをお持ちですか？",
      loading: "読み込み中...",
      verify: "確認",
      verified: "確認済み",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "マイ注文",
      createOrder: "新規注文作成",
      cancel: "キャンセル",
      orderTitle: "注文タイトル",
      description: "説明",
      packageDescription: "荷物説明",
      packageWeight: "荷物の重量 (kg)",
      estimatedValue: "推定価値 ($)",
      specialInstructions: "特別指示",
      estimatedDelivery: "推定配送日",
      price: "提示価格 ($)",
      publishOrder: "注文を公開",
      publishingOrder: "注文を公開中...",
      pickupLocation: "集荷場所",
      deliveryLocation: "配送場所",
      country: "国",
      city: "都市",
      area: "地域",
      street: "通り",
      building: "建物",
      floor: "階",
      apartment: "アパート",
      contactName: "連絡先名",
      selectCountry: "国を選択",
      enterCity: "都市を入力",
      enterArea: "地域を入力",
      enterStreet: "通りを入力",
      buildingNumber: "建物番号",
      aptNumber: "アパート番号",
      contactPerson: "連絡先",
      orderNumber: "注文番号",
      pickup: "集荷",
      delivery: "配送",
      package: "荷物",
      weight: "重量",
      value: "価値",
      instructions: "指示",
      trackOrder: "注文を追跡",
      viewReviews: "レビューを見る",
      noOrders: "利用可能な注文がありません",
      required: "必須",
      optional: "任意",
      orderTitleRequired: "注文タイトルは必須です",
      priceRequired: "価格は必須です",
      pickupCountryRequired: "集荷国は必須です",
      pickupCityRequired: "集荷都市は必須です",
      pickupContactRequired: "集荷連絡先名は必須です",
      deliveryCountryRequired: "配送国は必須です",
      deliveryCityRequired: "配送都市は必須です",
      deliveryContactRequired: "配送連絡先名は必須です",
      placeYourBid: "入札してください",
      messageOptional: "メッセージ（任意）",
      bidding: "入札中...",
      pickingUp: "集荷中...",
      updating: "更新中...",
      completing: "完了中...",
      markAsPickedUp: "集荷済みとしてマーク",
      markAsInTransit: "配送中としてマーク",
      markAsDelivered: "配送完了としてマーク",
      acceptedBid: "承認された入札",
      assignedDriver: "割り当てられたドライバー",
      orderAccepted: "注文が承認されました。ドライバーがすぐに集荷します。",
      packagePickedUp: "荷物が集荷され、配送中です！",
      packageInTransit: "荷物が配送中です。まもなくお届けします！",
      orderCompletedSuccessfully: "注文が正常に完了しました！",
      orderCancelled: "注文がキャンセルされました。",
      createNewOrder: "新規注文作成",
      clearFilter: "フィルターをクリア",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "入札待ち",
      accepted: "承認済み",
      pickedUp: "集荷済み",
      inTransit: "配送中",
      delivered: "配送完了",
      courierDelivered: "配達員が配達完了",
      customerDelivered: "配達確認済み",
      completed: "完了",
      cancelled: "キャンセル済み",
    },
    driver: {
      activeOrders: "アクティブ注文",
      availableBids: "利用可能な入札",
      myHistory: "履歴",
      updateLocation: "位置情報を更新",
      locationUpdated: "位置情報が更新されました",
      enableLocation: "注文の視認性を高めるために位置情報を有効化",
      locationDenied: "位置情報アクセスが拒否されました",
      placeBid: "入札する",
      placingBid: "入札中...",
      bidAmount: "入札金額 ($)",
      pickupTime: "集荷時間",
      message: "メッセージ（任意）",
      driverBids: "ドライバー入札",
      acceptBid: "入札を承認",
      acceptingBid: "承認中...",
      markPickedUp: "集荷済みとしてマーク",
      markInTransit: "配送中としてマーク",
      markDelivered: "配送完了としてマーク",
      pickingUp: "集荷中...",
      updating: "更新中...",
      completing: "完了中...",
      distanceFromPickup: "集荷場所からの距離",
      filterByCity: "都市でフィルター：",
      allCities: "すべての都市",
      clearFilter: "フィルターをクリア",
      noActiveOrders: "アクティブな注文が見つかりません",
      noAvailableBids: "利用可能な入札がありません",
      noOrderHistory: "注文履歴がありません",
    },
    reputation: {
      customerReputation: "顧客評価",
      driverReputation: "ドライバー評価",
      rating: "評価",
      deliveries: "配送",
      reviews: "レビュー",
      memberSince: "メンバー登録日",
      reviewsGiven: "与えたレビュー",
      viewReviews: "レビューを見る",
      given: "与えた",
      verifyAccount: "アカウントを確認",
    },
    reviews: {
      submitReview: "レビューを送信",
      reviewDriver: "ドライバーを評価",
      reviewCustomer: "顧客を評価",
      reviewPlatform: "プラットフォームを評価",
      overallRating: "全体評価",
      professionalism: "プロフェッショナリズム",
      communication: "コミュニケーション",
      timeliness: "時間厳守",
      packageCondition: "荷物の状態",
      comment: "コメント（任意）",
      shareExperience: "体験を共有してください...",
      cancel: "キャンセル",
      submit: "レビューを送信",
      submitting: "送信中...",
      provideRating: "全体評価を提供してください",
      orderReviews: "注文レビュー",
      noReviews: "この注文のレビューはまだありません",
      reviewType: "レビュータイプ",
      reviewing: "評価中",
    },
    notifications: {
      notifications: "通知",
      noNotifications: "通知がありません",
      newNotification: "新しい通知",
    },
    tracking: {
      orderTracking: "注文追跡",
      liveTracking: "ライブ追跡",
      currentStatus: "現在のステータス",
      currentLocation: "現在の位置",
      timeline: "タイムライン",
      orderCreated: "注文が作成されました",
      bidAccepted: "入札が承認されました",
      packagePickedUp: "荷物が集荷されました",
      locationHistory: "位置履歴",
      close: "閉じる",
      liveTrackingActive: "ライブ追跡がアクティブ",
      connecting: "接続中...",
      selectedLocation: "選択された位置",
      coordinates: "座標",
      copyCoordinates: "座標をコピー",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "注文が正常に公開されました！あなたの地域のドライバーを待っています。",
      bidPlaced: "入札が正常に行われました！",
      bidAccepted: "入札が正常に承認されました！ドライバーに通知されました。",
      orderAccepted:
        "あなたの注文が承認されました。ドライバーがすぐに集荷します。",
      orderPickedUp: "あなたの荷物が集荷され、配送中です！",
      orderInTransit: "あなたの荷物が配送中です。まもなくお届けします！",
      orderCompleted: "注文が正常に完了しました！",
      orderCancelled: "注文がキャンセルされました。",
      reviewSubmitted: "レビューが正常に送信されました！",
      allFieldsRequired: "すべてのフィールドが必須です",
      vehicleTypeRequired: "ドライバーには車両タイプが必須です",
      completeCaptcha: "CAPTCHAを完了してください",
      enterValidBid: "有効な入札価格を入力してください",
      fillRequiredFields: "すべての必須フィールドを入力してください",
      connectionIssue:
        "接続の問題：ユーザー情報を取得できませんでした。ページを更新してください。",
      locationAccessFailed:
        "位置情報アクセスに失敗しました。位置情報サービスを有効にしてください。",
      afterVerification:
        "管理者があなたのアカウントを確認した後、このページを更新して確認バッジを表示してください。",
    },
    common: {
      loading: "読み込み中...",
      error: "エラー",
      success: "成功",
      confirm: "確認",
      cancel: "キャンセル",
      save: "保存",
      delete: "削除",
      edit: "編集",
      search: "検索",
      filter: "フィルター",
      clear: "クリア",
      close: "閉じる",
      back: "戻る",
      next: "次へ",
      previous: "前へ",
      yes: "はい",
      no: "いいえ",
      optional: "任意",
      required: "必須",
      appName: "Matrix Heroes",
      subtitle: "P2P 配送マーケット",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "英語",
      spanish: "スペイン語",
      french: "フランス語",
      chinese: "中国語",
      german: "ドイツ語",
      portuguese: "ポルトガル語",
      arabic: "アラビア語",
      russian: "ロシア語",
      japanese: "日本語",
      turkish: "トルコ語",
      urdu: "ウルドゥー語",
      hindi: "ヒンディー語",
    },
  },
  tr: {
    auth: {
      signIn: "Giriş Yap",
      signUp: "Kaydol",
      createAccount: "Hesap Oluştur",
      email: "E-posta",
      password: "Şifre",
      fullName: "Tam Ad",
      phoneNumber: "Telefon Numarası",
      primary_role: "Rol",
      customer: "Müşteri",
      driver: "Sürücü",
      vehicleType: "Araç Tipi",
      selectVehicleType: "Araç Tipi Seç",
      walker: "Yaya",
      bicycle: "Bisiklet",
      bike: "Bisiklet",
      car: "Araba",
      van: "Van",
      truck: "Kamyon",
      login: "Giriş Yap",
      register: "Hesap Oluştur",
      logout: "Çıkış Yap",
      dontHaveAccount: "Hesabınız yok mu?",
      alreadyHaveAccount: "Zaten hesabınız var mı?",
      loading: "Yükleniyor...",
      verify: "Doğrula",
      verified: "Doğrulandı",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "Siparişlerim",
      createOrder: "Yeni Sipariş Oluştur",
      cancel: "İptal",
      orderTitle: "Sipariş Başlığı",
      description: "Açıklama",
      packageDescription: "Paket Açıklaması",
      packageWeight: "Paket Ağırlığı (kg)",
      estimatedValue: "Tahmini Değer ($)",
      specialInstructions: "Özel Talimatlar",
      estimatedDelivery: "Tahmini Teslimat Tarihi",
      price: "Teklif Edilen Fiyat ($)",
      publishOrder: "Siparişi Yayınla",
      publishingOrder: "Sipariş yayınlanıyor...",
      pickupLocation: "Alış Yeri",
      deliveryLocation: "Teslimat Yeri",
      country: "Ülke",
      city: "Şehir",
      area: "Bölge",
      street: "Sokak",
      building: "Bina",
      floor: "Kat",
      apartment: "Daire",
      contactName: "İletişim Adı",
      selectCountry: "Ülke Seç",
      enterCity: "Şehir girin",
      enterArea: "Bölge girin",
      enterStreet: "Sokak girin",
      buildingNumber: "Bina No",
      aptNumber: "Daire No",
      contactPerson: "İletişim kişisi",
      orderNumber: "Sipariş No",
      pickup: "Alış",
      delivery: "Teslimat",
      package: "Paket",
      weight: "Ağırlık",
      value: "Değer",
      instructions: "Talimatlar",
      trackOrder: "Siparişi Takip Et",
      viewReviews: "Değerlendirmeleri Görüntüle",
      noOrders: "Kullanılabilir sipariş yok",
      required: "Gerekli",
      optional: "İsteğe bağlı",
      orderTitleRequired: "Sipariş başlığı gerekli",
      priceRequired: "Fiyat gerekli",
      pickupCountryRequired: "Alış ülkesi gerekli",
      pickupCityRequired: "Alış şehri gerekli",
      pickupContactRequired: "Alış iletişim adı gerekli",
      deliveryCountryRequired: "Teslimat ülkesi gerekli",
      deliveryCityRequired: "Teslimat şehri gerekli",
      deliveryContactRequired: "Teslimat iletişim adı gerekli",
      placeYourBid: "Teklifinizi verin",
      messageOptional: "Mesaj (isteğe bağlı)",
      bidding: "Teklif veriliyor...",
      pickingUp: "Alınıyor...",
      updating: "Güncelleniyor...",
      completing: "Tamamlanıyor...",
      markAsPickedUp: "Alındı olarak işaretle",
      markAsInTransit: "Yolda olarak işaretle",
      markAsDelivered: "Teslim edildi olarak işaretle",
      acceptedBid: "Kabul edilen teklif",
      assignedDriver: "Atanan sürücü",
      orderAccepted: "Siparişiniz kabul edildi. Sürücü yakında alacak.",
      packagePickedUp: "Paketiniz alındı ve yolda!",
      packageInTransit: "Paketiniz yolda ve yakında teslim edilecek!",
      orderCompletedSuccessfully: "Sipariş başarıyla tamamlandı!",
      orderCancelled: "Sipariş iptal edildi.",
      createNewOrder: "Yeni Sipariş Oluştur",
      clearFilter: "Filtreyi Temizle",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "Teklif Bekleniyor",
      accepted: "Kabul Edildi",
      pickedUp: "Alındı",
      inTransit: "Yolda",
      delivered: "Teslim Edildi",
      courierDelivered: "Kurye tarafından teslim edildi",
      customerDelivered: "Teslimat onaylandı",
      completed: "Tamamlandı",
      cancelled: "İptal Edildi",
    },
    driver: {
      activeOrders: "Aktif Siparişler",
      availableBids: "Mevcut Teklifler",
      myHistory: "Geçmişim",
      updateLocation: "Konumu Güncelle",
      locationUpdated: "Konum Güncellendi",
      enableLocation: "Sipariş görünürlüğünü artırmak için konumu etkinleştir",
      locationDenied: "Konum erişimi reddedildi",
      placeBid: "Teklif Ver",
      placingBid: "Teklif veriliyor...",
      bidAmount: "Teklif Tutarı ($)",
      pickupTime: "Alış Zamanı",
      message: "Mesaj (isteğe bağlı)",
      driverBids: "Sürücü Teklifleri",
      acceptBid: "Teklifi Kabul Et",
      acceptingBid: "Kabul ediliyor...",
      markPickedUp: "Alındı Olarak İşaretle",
      markInTransit: "Yolda Olarak İşaretle",
      markDelivered: "Teslim Edildi Olarak İşaretle",
      pickingUp: "Alınıyor...",
      updating: "Güncelleniyor...",
      completing: "Tamamlanıyor...",
      distanceFromPickup: "Alış yerinden uzaklık",
      filterByCity: "Şehre göre filtrele:",
      allCities: "Tüm Şehirler",
      clearFilter: "Filtreyi Temizle",
      noActiveOrders: "Aktif sipariş bulunamadı",
      noAvailableBids: "Mevcut teklif yok",
      noOrderHistory: "Sipariş geçmişi yok",
    },
    reputation: {
      customerReputation: "Müşteri İtibarı",
      driverReputation: "Sürücü İtibarı",
      rating: "Değerlendirme",
      deliveries: "Teslimatlar",
      reviews: "Değerlendirmeler",
      memberSince: "Üyelik Tarihi",
      reviewsGiven: "Verilen Değerlendirmeler",
      viewReviews: "Değerlendirmeleri Görüntüle",
      given: "Verildi",
      verifyAccount: "Hesabı Doğrula",
    },
    reviews: {
      submitReview: "Değerlendirme Gönder",
      reviewDriver: "Sürücüyü Değerlendir",
      reviewCustomer: "Müşteriyi Değerlendir",
      reviewPlatform: "Platformu Değerlendir",
      overallRating: "Genel Değerlendirme",
      professionalism: "Profesyonellik",
      communication: "İletişim",
      timeliness: "Zamanında Teslimat",
      packageCondition: "Paket Durumu",
      comment: "Yorum (İsteğe bağlı)",
      shareExperience: "Deneyiminizi paylaşın...",
      cancel: "İptal",
      submit: "Değerlendirme Gönder",
      submitting: "Gönderiliyor...",
      provideRating: "Lütfen genel bir değerlendirme sağlayın",
      orderReviews: "Sipariş Değerlendirmeleri",
      noReviews: "Bu sipariş için henüz değerlendirme yok",
      reviewType: "Değerlendirme Tipi",
      reviewing: "Değerlendiriliyor",
    },
    notifications: {
      notifications: "Bildirimler",
      noNotifications: "Bildirim yok",
      newNotification: "Yeni bildirim",
    },
    tracking: {
      orderTracking: "Sipariş Takibi",
      liveTracking: "Canlı Takip",
      currentStatus: "Mevcut Durum",
      currentLocation: "Mevcut Konum",
      timeline: "Zaman Çizelgesi",
      orderCreated: "Sipariş Oluşturuldu",
      bidAccepted: "Teklif Kabul Edildi",
      packagePickedUp: "Paket Alındı",
      locationHistory: "Konum Geçmişi",
      close: "Kapat",
      liveTrackingActive: "Canlı Takip Aktif",
      connecting: "Bağlanıyor...",
      selectedLocation: "Seçilen Konum",
      coordinates: "Koordinatlar",
      copyCoordinates: "Koordinatları Kopyala",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "Sipariş başarıyla yayınlandı! Bölgenizdeki sürücüleri bekliyor.",
      bidPlaced: "Teklif başarıyla verildi!",
      bidAccepted: "Teklif başarıyla kabul edildi! Sürücü bilgilendirildi.",
      orderAccepted: "Siparişiniz kabul edildi. Sürücü yakında alacak.",
      orderPickedUp: "Paketiniz alındı ve yolda!",
      orderInTransit: "Paketiniz yolda ve yakında teslim edilecek!",
      orderCompleted: "Sipariş başarıyla tamamlandı!",
      orderCancelled: "Sipariş iptal edildi.",
      reviewSubmitted: "Değerlendirme başarıyla gönderildi!",
      allFieldsRequired: "Tüm alanlar zorunludur",
      vehicleTypeRequired: "Sürücüler için araç tipi zorunludur",
      completeCaptcha: "Lütfen captcha'yı tamamlayın",
      enterValidBid: "Geçerli bir teklif fiyatı girin",
      fillRequiredFields: "Lütfen tüm zorunlu alanları doldurun",
      connectionIssue:
        "Bağlantı sorunu: Kullanıcı bilgileri alınamadı. Lütfen sayfayı yenileyin.",
      locationAccessFailed:
        "Konum erişimi başarısız oldu. Lütfen konum servislerini etkinleştirin.",
      afterVerification:
        "Yönetici hesabınızı doğruladıktan sonra, lütfen bu sayfayı yenileyerek doğrulama rozetini görün.",
    },
    common: {
      loading: "Yükleniyor...",
      error: "Hata",
      success: "Başarılı",
      confirm: "Onayla",
      cancel: "İptal",
      save: "Kaydet",
      delete: "Sil",
      edit: "Düzenle",
      search: "Ara",
      filter: "Filtre",
      clear: "Temizle",
      close: "Kapat",
      back: "Geri",
      next: "İleri",
      previous: "Önceki",
      yes: "Evet",
      no: "Hayır",
      optional: "İsteğe bağlı",
      required: "Zorunlu",
      appName: "Matrix Heroes",
      subtitle: "P2P Teslimat Pazarı",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "İngilizce",
      spanish: "İspanyolca",
      french: "Fransızca",
      chinese: "Çince",
      german: "Almanca",
      portuguese: "Portekizce",
      arabic: "Arapça",
      russian: "Rusça",
      japanese: "Japonca",
      turkish: "Türkçe",
      urdu: "Urduca",
      hindi: "Hintçe",
    },
  },
  ur: {
    auth: {
      signIn: "سائن ان کریں",
      signUp: "سائن اپ کریں",
      createAccount: "اکاؤنٹ بنائیں",
      email: "ای میل",
      password: "پاس ورڈ",
      fullName: "پورا نام",
      phoneNumber: "فون نمبر",
      primary_role: "کردار",
      customer: "کسٹمر",
      driver: "ڈرائیور",
      vehicleType: "گاڑی کی قسم",
      selectVehicleType: "گاڑی کی قسم منتخب کریں",
      walker: "پیدل",
      bicycle: "سائیکل",
      bike: "موٹر سائیکل",
      car: "کار",
      van: "وین",
      truck: "ٹرک",
      login: "لاگ ان کریں",
      register: "اکاؤنٹ بنائیں",
      logout: "لاگ آؤٹ کریں",
      dontHaveAccount: "کیا آپ کا اکاؤنٹ نہیں ہے؟",
      alreadyHaveAccount: "کیا آپ کا پہلے سے اکاؤنٹ ہے؟",
      loading: "لوڈ ہو رہا ہے...",
      verify: "تصدیق کریں",
      verified: "تصدیق شدہ",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "میرے آرڈرز",
      createOrder: "نیا آرڈر بنائیں",
      cancel: "منسوخ کریں",
      orderTitle: "آرڈر کا عنوان",
      description: "تفصیل",
      packageDescription: "پیکیج کی تفصیل",
      packageWeight: "پیکیج کا وزن (kg)",
      estimatedValue: "تخمینی قیمت ($)",
      specialInstructions: "خصوصی ہدایات",
      estimatedDelivery: "تخمینی ڈیلیوری تاریخ",
      price: "پیش کردہ قیمت ($)",
      publishOrder: "آرڈر شائع کریں",
      publishingOrder: "آرڈر شائع ہو رہا ہے...",
      pickupLocation: "پک اپ لوکیشن",
      deliveryLocation: "ڈیلیوری لوکیشن",
      country: "ملک",
      city: "شہر",
      area: "علاقہ",
      street: "گلی",
      building: "عمارت",
      floor: "منزل",
      apartment: "اپارٹمنٹ",
      contactName: "رابطہ نام",
      selectCountry: "ملک منتخب کریں",
      enterCity: "شہر درج کریں",
      enterArea: "علاقہ درج کریں",
      enterStreet: "گلی درج کریں",
      buildingNumber: "عمارت نمبر",
      aptNumber: "اپارٹمنٹ نمبر",
      contactPerson: "رابطہ شخص",
      orderNumber: "آرڈر نمبر",
      pickup: "پک اپ",
      delivery: "ڈیلیوری",
      package: "پیکیج",
      weight: "وزن",
      value: "قیمت",
      instructions: "ہدایات",
      trackOrder: "آرڈر ٹریک کریں",
      viewReviews: "جائزے دیکھیں",
      noOrders: "کوئی آرڈرز دستیاب نہیں",
      required: "ضروری",
      optional: "اختیاری",
      orderTitleRequired: "آرڈر کا عنوان ضروری ہے",
      priceRequired: "قیمت ضروری ہے",
      pickupCountryRequired: "پک اپ ملک ضروری ہے",
      pickupCityRequired: "پک اپ شہر ضروری ہے",
      pickupContactRequired: "پک اپ رابطہ نام ضروری ہے",
      deliveryCountryRequired: "ڈیلیوری ملک ضروری ہے",
      deliveryCityRequired: "ڈیلیوری شہر ضروری ہے",
      deliveryContactRequired: "ڈیلیوری رابطہ نام ضروری ہے",
      placeYourBid: "اپنی بولی لگائیں",
      messageOptional: "پیغام (اختیاری)",
      bidding: "بولی لگا رہے ہیں...",
      pickingUp: "پک اپ کر رہے ہیں...",
      updating: "اپ ڈیٹ کر رہے ہیں...",
      completing: "مکمل کر رہے ہیں...",
      markAsPickedUp: "پک اپ شدہ کے طور پر نشان زد کریں",
      markAsInTransit: "راستے میں کے طور پر نشان زد کریں",
      markAsDelivered: "ڈیلیور شدہ کے طور پر نشان زد کریں",
      acceptedBid: "قبول شدہ بولی",
      assignedDriver: "تفویض کردہ ڈرائیور",
      orderAccepted: "آپ کا آرڈر قبول کر لیا گیا ہے۔ ڈرائیور جلد پک اپ کرے گا۔",
      packagePickedUp: "آپ کا پیکیج پک اپ کر لیا گیا ہے اور راستے میں ہے!",
      packageInTransit:
        "آپ کا پیکیج راستے میں ہے اور جلد ڈیلیور کر دیا جائے گا!",
      orderCompletedSuccessfully: "آرڈر کامیابی سے مکمل کر دیا گیا!",
      orderCancelled: "آرڈر منسوخ کر دیا گیا۔",
      createNewOrder: "نیا آرڈر بنائیں",
      clearFilter: "فلٹر صاف کریں",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "بولیاں زیر التواء",
      accepted: "قبول کر لیا گیا",
      pickedUp: "پک اپ کر لیا گیا",
      inTransit: "راستے میں",
      delivered: "ڈیلیور کر دیا گیا",
      courierDelivered: "کوریر نے پہنچا دیا",
      customerDelivered: "ترسیل کی تصدیق ہو گئی",
      completed: "مکمل",
      cancelled: "منسوخ کر دیا گیا",
    },
    driver: {
      activeOrders: "فعال آرڈرز",
      availableBids: "دستیاب بولیاں",
      myHistory: "میری تاریخ",
      updateLocation: "لوکیشن اپ ڈیٹ کریں",
      locationUpdated: "لوکیشن اپ ڈیٹ کر دی گئی",
      enableLocation: "آرڈر کی بہتر مرئیت کے لیے لوکیشن فعال کریں",
      locationDenied: "لوکیشن تک رسائی مسترد کر دی گئی",
      placeBid: "بولی لگائیں",
      placingBid: "بولی لگا رہے ہیں...",
      bidAmount: "بولی کی رقم ($)",
      pickupTime: "پک اپ کا وقت",
      message: "پیغام (اختیاری)",
      driverBids: "ڈرائیور کی بولیاں",
      acceptBid: "بولی قبول کریں",
      acceptingBid: "قبول کر رہے ہیں...",
      markPickedUp: "پک اپ شدہ کے طور پر نشان زد کریں",
      markInTransit: "راستے میں کے طور پر نشان زد کریں",
      markDelivered: "ڈیلیور شدہ کے طور پر نشان زد کریں",
      pickingUp: "پک اپ کر رہے ہیں...",
      updating: "اپ ڈیٹ کر رہے ہیں...",
      completing: "مکمل کر رہے ہیں...",
      distanceFromPickup: "پک اپ لوکیشن سے فاصلہ",
      filterByCity: "شہر کے مطابق فلٹر کریں:",
      allCities: "تمام شہر",
      clearFilter: "فلٹر صاف کریں",
      noActiveOrders: "کوئی فعال آرڈرز نہیں ملے",
      noAvailableBids: "کوئی دستیاب بولیاں نہیں",
      noOrderHistory: "آرڈر کی کوئی تاریخ نہیں",
    },
    reputation: {
      customerReputation: "کسٹمر کی ساکھ",
      driverReputation: "ڈرائیور کی ساکھ",
      rating: "درجہ بندی",
      deliveries: "ڈیلیوریز",
      reviews: "جائزے",
      memberSince: "رکنیت کی تاریخ",
      reviewsGiven: "دیے گئے جائزے",
      viewReviews: "جائزے دیکھیں",
      given: "دیے گئے",
      verifyAccount: "اکاؤنٹ کی تصدیق کریں",
    },
    reviews: {
      submitReview: "جائزہ جمع کرائیں",
      reviewDriver: "ڈرائیور کا جائزہ لیں",
      reviewCustomer: "کسٹمر کا جائزہ لیں",
      reviewPlatform: "پلیٹ فارم کا جائزہ لیں",
      overallRating: "مجموعی درجہ بندی",
      professionalism: "پیشہ ورانہ پن",
      communication: "رابطہ",
      timeliness: "وقت پر ڈیلیوری",
      packageCondition: "پیکیج کی حالت",
      comment: "تبصرہ (اختیاری)",
      shareExperience: "اپنا تجربہ شیئر کریں...",
      cancel: "منسوخ کریں",
      submit: "جائزہ جمع کرائیں",
      submitting: "جمع کرا رہے ہیں...",
      provideRating: "براہ کرم مجموعی درجہ بندی فراہم کریں",
      orderReviews: "آرڈر کے جائزے",
      noReviews: "اس آرڈر کے لیے ابھی کوئی جائزہ نہیں",
      reviewType: "جائزے کی قسم",
      reviewing: "جائزہ لے رہے ہیں",
    },
    notifications: {
      notifications: "اطلاعات",
      noNotifications: "کوئی اطلاع نہیں",
      newNotification: "نئی اطلاع",
    },
    tracking: {
      orderTracking: "آرڈر ٹریکنگ",
      liveTracking: "لائیو ٹریکنگ",
      currentStatus: "موجودہ حیثیت",
      currentLocation: "موجودہ لوکیشن",
      timeline: "ٹائم لائن",
      orderCreated: "آرڈر بنایا گیا",
      bidAccepted: "بولی قبول کر لی گئی",
      packagePickedUp: "پیکیج پک اپ کر لیا گیا",
      locationHistory: "لوکیشن کی تاریخ",
      close: "بند کریں",
      liveTrackingActive: "لائیو ٹریکنگ فعال",
      connecting: "کنیکٹ ہو رہے ہیں...",
      selectedLocation: "منتخب کردہ لوکیشن",
      coordinates: "کوآرڈینیٹس",
      copyCoordinates: "کوآرڈینیٹس کاپی کریں",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "آرڈر کامیابی سے شائع کر دیا گیا! آپ کے علاقے کے ڈرائیورز کا انتظار کر رہے ہیں۔",
      bidPlaced: "بولی کامیابی سے لگا دی گئی!",
      bidAccepted:
        "بولی کامیابی سے قبول کر لی گئی! ڈرائیور کو مطلع کر دیا گیا۔",
      orderAccepted: "آپ کا آرڈر قبول کر لیا گیا ہے۔ ڈرائیور جلد پک اپ کرے گا۔",
      orderPickedUp: "آپ کا پیکیج پک اپ کر لیا گیا ہے اور راستے میں ہے!",
      orderInTransit: "آپ کا پیکیج راستے میں ہے اور جلد ڈیلیور کر دیا جائے گا!",
      orderCompleted: "آرڈر کامیابی سے مکمل کر دیا گیا!",
      orderCancelled: "آرڈر منسوخ کر دیا گیا۔",
      reviewSubmitted: "جائزہ کامیابی سے جمع کرا دیا گیا!",
      allFieldsRequired: "تمام فیلڈز ضروری ہیں",
      vehicleTypeRequired: "ڈرائیورز کے لیے گاڑی کی قسم ضروری ہے",
      completeCaptcha: "براہ کرم کیپچا مکمل کریں",
      enterValidBid: "درست بولی کی قیمت درج کریں",
      fillRequiredFields: "براہ کرم تمام ضروری فیلڈز بھریں",
      connectionIssue:
        "کنکشن کا مسئلہ: صارف کی معلومات حاصل نہیں کی جا سکیں۔ براہ کرم صفحہ ریفریش کریں۔",
      locationAccessFailed:
        "لوکیشن تک رسائی ناکام ہو گئی۔ براہ کرم لوکیشن سروسز فعال کریں۔",
      afterVerification:
        "ایڈمن نے آپ کے اکاؤنٹ کی تصدیق کر دی ہے، براہ کرم اس صفحے کو ریفریش کریں تاکہ تصدیقی بیج نظر آئے۔",
    },
    common: {
      loading: "لوڈ ہو رہا ہے...",
      error: "خرابی",
      success: "کامیابی",
      confirm: "تصدیق کریں",
      cancel: "منسوخ کریں",
      save: "محفوظ کریں",
      delete: "حذف کریں",
      edit: "ترمیم کریں",
      search: "تلاش کریں",
      filter: "فلٹر کریں",
      clear: "صاف کریں",
      close: "بند کریں",
      back: "پیچھے",
      next: "اگلا",
      previous: "پچھلا",
      yes: "ہاں",
      no: "نہیں",
      optional: "اختیاری",
      required: "ضروری",
      appName: "Matrix Heroes",
      subtitle: "P2P ڈیلیوری مارکیٹ",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "English",
      spanish: "Español",
      french: "Français",
      chinese: "中文",
      german: "Deutsch",
      portuguese: "Português",
      arabic: "العربية",
      russian: "Русский",
      japanese: "日本語",
      turkish: "Türkçe",
      urdu: "اردو",
      hindi: "हिन्दी",
    },
  },
  hi: {
    auth: {
      signIn: "साइन इन करें",
      signUp: "साइन अप करें",
      createAccount: "खाता बनाएं",
      email: "ईमेल",
      password: "पासवर्ड",
      fullName: "पूरा नाम",
      phoneNumber: "फोन नंबर",
      primary_role: "भूमिका",
      customer: "ग्राहक",
      driver: "ड्राइवर",
      vehicleType: "वाहन प्रकार",
      selectVehicleType: "वाहन प्रकार चुनें",
      walker: "पैदल",
      bicycle: "साइकिल",
      bike: "मोटरसाइकिल",
      car: "कार",
      van: "वैन",
      truck: "ट्रक",
      login: "लॉग इन करें",
      register: "खाता बनाएं",
      logout: "लॉग आउट करें",
      dontHaveAccount: "क्या आपके पास खाता नहीं है?",
      alreadyHaveAccount: "क्या आपके पास पहले से खाता है?",
      loading: "लोड हो रहा है...",
      verify: "सत्यापित करें",
      verified: "सत्यापित",
      showPassword: "Show",
      hidePassword: "Hide",
      resendVerification: "Resend Verification",
      emailVerificationRequired: "Email verification required",
      verifyYourEmail: "Verify your email",
    },
    orders: {
      myOrders: "मेरे ऑर्डर",
      createOrder: "नया ऑर्डर बनाएं",
      cancel: "रद्द करें",
      orderTitle: "ऑर्डर का शीर्षक",
      description: "विवरण",
      packageDescription: "पैकेज विवरण",
      packageWeight: "पैकेज का वजन (kg)",
      estimatedValue: "अनुमानित मूल्य ($)",
      specialInstructions: "विशेष निर्देश",
      estimatedDelivery: "अनुमानित डिलीवरी तिथि",
      price: "प्रस्तावित मूल्य ($)",
      publishOrder: "ऑर्डर प्रकाशित करें",
      publishingOrder: "ऑर्डर प्रकाशित हो रहा है...",
      pickupLocation: "पिकअप स्थान",
      deliveryLocation: "डिलीवरी स्थान",
      country: "देश",
      city: "शहर",
      area: "क्षेत्र",
      street: "सड़क",
      building: "इमारत",
      floor: "मंजिल",
      apartment: "अपार्टमेंट",
      contactName: "संपर्क नाम",
      selectCountry: "देश चुनें",
      enterCity: "शहर दर्ज करें",
      enterArea: "क्षेत्र दर्ज करें",
      enterStreet: "सड़क दर्ज करें",
      buildingNumber: "इमारत संख्या",
      aptNumber: "अपार्टमेंट संख्या",
      contactPerson: "संपर्क व्यक्ति",
      orderNumber: "ऑर्डर संख्या",
      pickup: "पिकअप",
      delivery: "डिलीवरी",
      package: "पैकेज",
      weight: "वजन",
      value: "मूल्य",
      instructions: "निर्देश",
      trackOrder: "ऑर्डर ट्रैक करें",
      viewReviews: "समीक्षाएं देखें",
      noOrders: "कोई ऑर्डर उपलब्ध नहीं",
      required: "आवश्यक",
      optional: "वैकल्पिक",
      orderTitleRequired: "ऑर्डर का शीर्षक आवश्यक है",
      priceRequired: "मूल्य आवश्यक है",
      pickupCountryRequired: "पिकअप देश आवश्यक है",
      pickupCityRequired: "पिकअप शहर आवश्यक है",
      pickupContactRequired: "पिकअप संपर्क नाम आवश्यक है",
      deliveryCountryRequired: "डिलीवरी देश आवश्यक है",
      deliveryCityRequired: "डिलीवरी शहर आवश्यक है",
      deliveryContactRequired: "डिलीवरी संपर्क नाम आवश्यक है",
      placeYourBid: "अपनी बोली लगाएं",
      messageOptional: "संदेश (वैकल्पिक)",
      bidding: "बोली लगा रहे हैं...",
      pickingUp: "पिकअप कर रहे हैं...",
      updating: "अपडेट कर रहे हैं...",
      completing: "पूर्ण कर रहे हैं...",
      markAsPickedUp: "पिकअप किए गए के रूप में चिह्नित करें",
      markAsInTransit: "मार्ग में के रूप में चिह्नित करें",
      markAsDelivered: "डिलीवर किए गए के रूप में चिह्नित करें",
      acceptedBid: "स्वीकार की गई बोली",
      assignedDriver: "सौंपा गया ड्राइवर",
      orderAccepted:
        "आपका ऑर्डर स्वीकार कर लिया गया है। ड्राइवर जल्द ही पिकअप करेगा।",
      packagePickedUp: "आपका पैकेज पिकअप कर लिया गया है और मार्ग में है!",
      packageInTransit: "आपका पैकेज मार्ग में है और जल्द ही डिलीवर किया जाएगा!",
      orderCompletedSuccessfully: "ऑर्डर सफलतापूर्वक पूरा किया गया!",
      orderCancelled: "ऑर्डर रद्द कर दिया गया।",
      createNewOrder: "नया ऑर्डर बनाएं",
      clearFilter: "फ़िल्टर साफ़ करें",
      allCities: "All Cities",
      filterByCity: "Filter by City",
      noActiveOrders: "No active orders found",
      noAvailableBids: "No available bids",
      noOrderHistory: "No order history",
      noOrdersAvailable: "No orders available",
      bidAmount: "Bid Amount ($)",
      pickupTime: "Pickup Time",
      estimatedPickupTime: "Estimated Pickup Time",
      estimatedDeliveryTime: "Estimated Delivery Time",
      acceptingBid: "Accepting...",
      bidLabel: "Bid",
      pickupLocationFields: "Pickup location (country, city, contact name)",
      deliveryLocationFields: "Delivery location (country, city, contact name)",
      driver: "Driver",
      cancelOrder: "Cancel Order",
      orderNumberLabel: "Order #",
      km: "km",
      new: "New",
      unknown: "Unknown",
      packagePickedUpByDriver: "Package has been picked up by the driver.",
      packageInTransitToAddress:
        "Package is in transit to the delivery address.",
      orderCompletedSuccessfullyExclamation: "Order completed successfully!",
      orderHasBeenCancelled: "Order has been cancelled.",
      activeOrders: "Active Orders",
      orderDetails: "Order Details",
      title: "Title",
      contactPhone: "Contact Phone",
      packageDetails: "Package Details",
      estimatedDeliveryDate: "Estimated Delivery Date",
    },
    status: {
      pendingBids: "बोली लंबित",
      accepted: "स्वीकार किया गया",
      pickedUp: "पिकअप किया गया",
      inTransit: "मार्ग में",
      delivered: "डिलीवर किया गया",
      courierDelivered: "कूरियर द्वारा डिलीवर किया गया",
      customerDelivered: "डिलीवरी की पुष्टि हो गई",
      completed: "पूर्ण",
      cancelled: "रद्द किया गया",
    },
    driver: {
      activeOrders: "सक्रिय ऑर्डर",
      availableBids: "उपलब्ध बोली",
      myHistory: "मेरा इतिहास",
      updateLocation: "स्थान अपडेट करें",
      locationUpdated: "स्थान अपडेट किया गया",
      enableLocation: "ऑर्डर की बेहतर दृश्यता के लिए स्थान सक्षम करें",
      locationDenied: "स्थान पहुंच अस्वीकृत",
      placeBid: "बोली लगाएं",
      placingBid: "बोली लगा रहे हैं...",
      bidAmount: "बोली राशि ($)",
      pickupTime: "पिकअप समय",
      message: "संदेश (वैकल्पिक)",
      driverBids: "ड्राइवर की बोली",
      acceptBid: "बोली स्वीकार करें",
      acceptingBid: "स्वीकार कर रहे हैं...",
      markPickedUp: "पिकअप किए गए के रूप में चिह्नित करें",
      markInTransit: "मार्ग में के रूप में चिह्नित करें",
      markDelivered: "डिलीवर किए गए के रूप में चिह्नित करें",
      pickingUp: "पिकअप कर रहे हैं...",
      updating: "अपडेट कर रहे हैं...",
      completing: "पूर्ण कर रहे हैं...",
      distanceFromPickup: "पिकअप स्थान से दूरी",
      filterByCity: "शहर के अनुसार फ़िल्टर करें:",
      allCities: "सभी शहर",
      clearFilter: "फ़िल्टर साफ़ करें",
      noActiveOrders: "कोई सक्रिय ऑर्डर नहीं मिले",
      noAvailableBids: "कोई उपलब्ध बोली नहीं",
      noOrderHistory: "ऑर्डर का कोई इतिहास नहीं",
    },
    reputation: {
      customerReputation: "ग्राहक प्रतिष्ठा",
      driverReputation: "ड्राइवर प्रतिष्ठा",
      rating: "रेटिंग",
      deliveries: "डिलीवरी",
      reviews: "समीक्षाएं",
      memberSince: "सदस्यता तिथि",
      reviewsGiven: "दी गई समीक्षाएं",
      viewReviews: "समीक्षाएं देखें",
      given: "दी गई",
      verifyAccount: "खाता सत्यापित करें",
    },
    reviews: {
      submitReview: "समीक्षा सबमिट करें",
      reviewDriver: "ड्राइवर की समीक्षा करें",
      reviewCustomer: "ग्राहक की समीक्षा करें",
      reviewPlatform: "प्लेटफॉर्म की समीक्षा करें",
      overallRating: "समग्र रेटिंग",
      professionalism: "पेशेवरता",
      communication: "संचार",
      timeliness: "समय पर डिलीवरी",
      packageCondition: "पैकेज की स्थिति",
      comment: "टिप्पणी (वैकल्पिक)",
      shareExperience: "अपना अनुभव साझा करें...",
      cancel: "रद्द करें",
      submit: "समीक्षा सबमिट करें",
      submitting: "सबमिट कर रहे हैं...",
      provideRating: "कृपया समग्र रेटिंग प्रदान करें",
      orderReviews: "ऑर्डर समीक्षाएं",
      noReviews: "इस ऑर्डर के लिए अभी कोई समीक्षा नहीं",
      reviewType: "समीक्षा प्रकार",
      reviewing: "समीक्षा कर रहे हैं",
    },
    notifications: {
      notifications: "सूचनाएं",
      noNotifications: "कोई सूचना नहीं",
      newNotification: "नई सूचना",
    },
    tracking: {
      orderTracking: "ऑर्डर ट्रैकिंग",
      liveTracking: "लाइव ट्रैकिंग",
      currentStatus: "वर्तमान स्थिति",
      currentLocation: "वर्तमान स्थान",
      timeline: "समयरेखा",
      orderCreated: "ऑर्डर बनाया गया",
      bidAccepted: "बोली स्वीकार की गई",
      packagePickedUp: "पैकेज पिकअप किया गया",
      locationHistory: "स्थान इतिहास",
      close: "बंद करें",
      liveTrackingActive: "लाइव ट्रैकिंग सक्रिय",
      connecting: "कनेक्ट हो रहा है...",
      selectedLocation: "चयनित स्थान",
      coordinates: "निर्देशांक",
      copyCoordinates: "निर्देशांक कॉपी करें",
      pickup: "पिकअप",
      delivery: "डिलीवरी",
      driver: "ड्राइवर",
      orderNumber: "Order #",
    },
    messages: {
      orderPublished:
        "ऑर्डर सफलतापूर्वक प्रकाशित किया गया! आपके क्षेत्र के ड्राइवरों का इंतजार कर रहे हैं।",
      bidPlaced: "बोली सफलतापूर्वक लगाई गई!",
      bidAccepted: "बोली सफलतापूर्वक स्वीकार की गई! ड्राइवर को सूचित किया गया।",
      orderAccepted:
        "आपका ऑर्डर स्वीकार कर लिया गया है। ड्राइवर जल्द ही पिकअप करेगा।",
      orderPickedUp: "आपका पैकेज पिकअप कर लिया गया है और मार्ग में है!",
      orderInTransit: "आपका पैकेज मार्ग में है और जल्द ही डिलीवर किया जाएगा!",
      orderCompleted: "ऑर्डर सफलतापूर्वक पूरा किया गया!",
      orderCancelled: "ऑर्डर रद्द कर दिया गया।",
      reviewSubmitted: "समीक्षा सफलतापूर्वक सबमिट की गई!",
      allFieldsRequired: "सभी फ़ील्ड आवश्यक हैं",
      vehicleTypeRequired: "ड्राइवरों के लिए वाहन प्रकार आवश्यक है",
      completeCaptcha: "कृपया कैप्चा पूरा करें",
      enterValidBid: "मान्य बोली मूल्य दर्ज करें",
      fillRequiredFields: "कृपया सभी आवश्यक फ़ील्ड भरें",
      connectionIssue:
        "कनेक्शन समस्या: उपयोगकर्ता जानकारी प्राप्त नहीं की जा सकी। कृपया पृष्ठ रिफ्रेश करें।",
      locationAccessFailed:
        "स्थान पहुंच विफल हुई। कृपया स्थान सेवाएं सक्षम करें।",
      afterVerification:
        "व्यवस्थापक ने आपके खाते को सत्यापित कर दिया है, कृपया इस पृष्ठ को रिफ्रेश करें ताकि सत्यापन बैज दिखाई दे।",
    },
    common: {
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता",
      confirm: "पुष्टि करें",
      cancel: "रद्द करें",
      save: "सहेजें",
      delete: "हटाएं",
      edit: "संपादित करें",
      search: "खोजें",
      filter: "फ़िल्टर करें",
      clear: "साफ़ करें",
      close: "बंद करें",
      back: "पीछे",
      next: "अगला",
      previous: "पिछला",
      yes: "हाँ",
      no: "नहीं",
      optional: "वैकल्पिक",
      required: "आवश्यक",
      appName: "Matrix Heroes",
      subtitle: "P2P डिलीवरी बाजार",
      selectLanguage: "Select Language",
      vendorName: "Vendor Name",
      keyword: "Keyword",
      lat: "Latitude",
      lng: "Longitude",
      radius: "Radius (km)",
      category: "Category",
      vendorId: "Vendor ID",
      itemName: "Item Name",
      createVendor: "Create Vendor",
      yourLocation: "Your Location",
      driverCurrentLocation: "Driver Current Location",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      orderStatus: "Order Status",
      orderData: "Order Data",
      driverCoords: "Driver Coordinates",
      costPerKm: "Cost per KM",
      waitingPerHour: "Waiting per Hour",
      notifications: "Notifications",
      profile: "Profile",
      menu: "Menu",
      reorder: "Reorder",
      vendorDashboard: "Vendor Dashboard",
    },
    languages: {
      english: "अंग्रेजी",
      spanish: "स्पेनिश",
      french: "फ्रेंच",
      chinese: "चीनी",
      german: "जर्मन",
      portuguese: "पुर्तगाली",
      arabic: "अरबी",
      russian: "रूसी",
      japanese: "जापानी",
      turkish: "तुर्की",
      urdu: "उर्दू",
      hindi: "हिंदी",
    },
  },
};

const marketplaceTranslations = {
  en: {
    browseStores: "Marketplace",
    title: "Find stores near you",
    subtitle: "Local stores, clear distances, one simple place to start.",
    useLocation: "Use my location",
    findStores: "Find stores",
    locationError: "Location could not be accessed. Enter coordinates to search instead.",
    invalidCoordinates: "Enter a valid latitude and longitude.",
    loadError: "Nearby stores could not be loaded. Please try again.",
    emptyTitle: "No stores in this area",
    emptyHint: "Try a larger radius or a different location.",
    distance: "Distance",
    addressUnavailable: "Address not provided",
  },
  ar: {
    browseStores: "السوق",
    title: "اعثر على متاجر قريبة منك",
    subtitle: "متاجر محلية ومسافات واضحة وبداية بسيطة لطلبك التالي.",
    useLocation: "استخدم موقعي",
    findStores: "اعثر على المتاجر",
    locationError: "تعذر الوصول إلى موقعك. أدخل الإحداثيات للبحث.",
    invalidCoordinates: "أدخل خط عرض وخط طول صالحين.",
    loadError: "تعذر تحميل المتاجر القريبة. حاول مرة أخرى.",
    emptyTitle: "لا توجد متاجر في هذه المنطقة",
    emptyHint: "جرّب زيادة النطاق أو اختيار موقع آخر.",
    distance: "المسافة",
    addressUnavailable: "العنوان غير متوفر",
  },
  es: {
    browseStores: "Mercado",
    title: "Encuentra tiendas cerca de ti",
    subtitle: "Tiendas locales, distancias claras y un comienzo sencillo.",
    useLocation: "Usar mi ubicación",
    findStores: "Buscar tiendas",
    locationError: "No se pudo acceder a tu ubicación. Introduce las coordenadas para buscar.",
    invalidCoordinates: "Introduce una latitud y longitud válidas.",
    loadError: "No se pudieron cargar las tiendas cercanas. Inténtalo de nuevo.",
    emptyTitle: "No hay tiendas en esta zona",
    emptyHint: "Prueba con un radio mayor o con otra ubicación.",
    distance: "Distancia",
    addressUnavailable: "Dirección no disponible",
  },
  fr: {
    browseStores: "Marketplace",
    title: "Trouvez des magasins près de vous",
    subtitle: "Des commerces locaux, des distances claires et un départ simple.",
    useLocation: "Utiliser ma position",
    findStores: "Trouver des magasins",
    locationError: "Votre position est inaccessible. Saisissez des coordonnées pour lancer la recherche.",
    invalidCoordinates: "Saisissez une latitude et une longitude valides.",
    loadError: "Impossible de charger les magasins proches. Réessayez.",
    emptyTitle: "Aucun magasin dans cette zone",
    emptyHint: "Essayez un rayon plus large ou une autre position.",
    distance: "Distance",
    addressUnavailable: "Adresse non renseignée",
  },
  zh: {
    browseStores: "商城",
    title: "查找附近的商店",
    subtitle: "本地商店、清晰距离，让您轻松开始下一笔订单。",
    useLocation: "使用我的位置",
    findStores: "查找商店",
    locationError: "无法获取您的位置。请改为输入坐标进行搜索。",
    invalidCoordinates: "请输入有效的纬度和经度。",
    loadError: "无法加载附近商店，请重试。",
    emptyTitle: "此区域没有商店",
    emptyHint: "请尝试扩大范围或更换位置。",
    distance: "距离",
    addressUnavailable: "未提供地址",
  },
  de: {
    browseStores: "Marktplatz",
    title: "Geschäfte in deiner Nähe",
    subtitle: "Lokale Geschäfte, klare Entfernungen und ein einfacher Start.",
    useLocation: "Meinen Standort verwenden",
    findStores: "Geschäfte finden",
    locationError: "Der Standort ist nicht verfügbar. Gib stattdessen Koordinaten ein.",
    invalidCoordinates: "Gib einen gültigen Breiten- und Längengrad ein.",
    loadError: "Nahe Geschäfte konnten nicht geladen werden. Bitte erneut versuchen.",
    emptyTitle: "Keine Geschäfte in diesem Bereich",
    emptyHint: "Versuche einen größeren Radius oder einen anderen Standort.",
    distance: "Entfernung",
    addressUnavailable: "Keine Adresse angegeben",
  },
  pt: {
    browseStores: "Marketplace",
    title: "Encontre lojas perto de você",
    subtitle: "Lojas locais, distâncias claras e um jeito simples de começar.",
    useLocation: "Usar minha localização",
    findStores: "Encontrar lojas",
    locationError: "Não foi possível acessar sua localização. Informe as coordenadas para pesquisar.",
    invalidCoordinates: "Informe uma latitude e longitude válidas.",
    loadError: "Não foi possível carregar as lojas próximas. Tente novamente.",
    emptyTitle: "Não há lojas nesta área",
    emptyHint: "Tente um raio maior ou outro local.",
    distance: "Distância",
    addressUnavailable: "Endereço não informado",
  },
  ru: {
    browseStores: "Маркетплейс",
    title: "Найдите магазины рядом",
    subtitle: "Местные магазины, понятные расстояния и простой старт.",
    useLocation: "Использовать моё местоположение",
    findStores: "Найти магазины",
    locationError: "Не удалось получить местоположение. Введите координаты для поиска.",
    invalidCoordinates: "Введите корректные широту и долготу.",
    loadError: "Не удалось загрузить магазины поблизости. Попробуйте ещё раз.",
    emptyTitle: "В этой области магазинов нет",
    emptyHint: "Увеличьте радиус или выберите другое место.",
    distance: "Расстояние",
    addressUnavailable: "Адрес не указан",
  },
  ja: {
    browseStores: "マーケットプレイス",
    title: "近くのお店を探す",
    subtitle: "距離がわかりやすい地域のお店から、次の注文を始めましょう。",
    useLocation: "現在地を使う",
    findStores: "お店を探す",
    locationError: "現在地を取得できません。座標を入力して検索してください。",
    invalidCoordinates: "有効な緯度と経度を入力してください。",
    loadError: "近くのお店を読み込めませんでした。もう一度お試しください。",
    emptyTitle: "この範囲にお店はありません",
    emptyHint: "検索範囲を広げるか、別の場所をお試しください。",
    distance: "距離",
    addressUnavailable: "住所は登録されていません",
  },
  tr: {
    browseStores: "Pazar yeri",
    title: "Yakınınızdaki mağazaları bulun",
    subtitle: "Yerel mağazalar, açık mesafeler ve kolay bir başlangıç.",
    useLocation: "Konumumu kullan",
    findStores: "Mağazaları bul",
    locationError: "Konumunuza erişilemedi. Aramak için koordinatları girin.",
    invalidCoordinates: "Geçerli bir enlem ve boylam girin.",
    loadError: "Yakındaki mağazalar yüklenemedi. Lütfen tekrar deneyin.",
    emptyTitle: "Bu bölgede mağaza yok",
    emptyHint: "Daha geniş bir yarıçap veya başka bir konum deneyin.",
    distance: "Mesafe",
    addressUnavailable: "Adres belirtilmedi",
  },
  ur: {
    browseStores: "مارکیٹ پلیس",
    title: "اپنے قریب دکانیں تلاش کریں",
    subtitle: "مقامی دکانیں، واضح فاصلے اور آسان آغاز۔",
    useLocation: "میرا مقام استعمال کریں",
    findStores: "دکانیں تلاش کریں",
    locationError: "مقام تک رسائی ممکن نہیں۔ تلاش کے لیے نقاط درج کریں۔",
    invalidCoordinates: "درست عرض البلد اور طول البلد درج کریں۔",
    loadError: "قریبی دکانیں لوڈ نہیں ہو سکیں۔ دوبارہ کوشش کریں۔",
    emptyTitle: "اس علاقے میں کوئی دکان نہیں",
    emptyHint: "زیادہ فاصلے یا کسی دوسرے مقام کے ساتھ کوشش کریں۔",
    distance: "فاصلہ",
    addressUnavailable: "پتہ فراہم نہیں کیا گیا",
  },
  hi: {
    browseStores: "मार्केटप्लेस",
    title: "अपने पास की दुकानें खोजें",
    subtitle: "स्थानीय दुकानें, स्पष्ट दूरी और ऑर्डर शुरू करने का आसान तरीका।",
    useLocation: "मेरी लोकेशन इस्तेमाल करें",
    findStores: "दुकानें खोजें",
    locationError: "लोकेशन उपलब्ध नहीं है। खोजने के लिए निर्देशांक दर्ज करें।",
    invalidCoordinates: "मान्य अक्षांश और देशांतर दर्ज करें।",
    loadError: "पास की दुकानें लोड नहीं हो सकीं। फिर से कोशिश करें।",
    emptyTitle: "इस क्षेत्र में कोई दुकान नहीं",
    emptyHint: "बड़ा दायरा या कोई दूसरी लोकेशन चुनकर देखें।",
    distance: "दूरी",
    addressUnavailable: "पता उपलब्ध नहीं है",
  },
};

translations.en.marketplace = marketplaceTranslations.en;
translations.ar.marketplace = marketplaceTranslations.ar;
translations.es.marketplace = marketplaceTranslations.es;
translations.fr.marketplace = marketplaceTranslations.fr;
translations.zh.marketplace = marketplaceTranslations.zh;
translations.de.marketplace = marketplaceTranslations.de;
translations.pt.marketplace = marketplaceTranslations.pt;
translations.ru.marketplace = marketplaceTranslations.ru;
translations.ja.marketplace = marketplaceTranslations.ja;
translations.tr.marketplace = marketplaceTranslations.tr;
translations.ur.marketplace = marketplaceTranslations.ur;
translations.hi.marketplace = marketplaceTranslations.hi;

export default translations;
